<template >
  <div id="root">
    <!-- 封面 -->
    <div class="pageOne">
      <div>
        <img id="homeImg"
             src="@/assets/images/wpsp/cash-cent-child-1246954.png"
             alt="">
        <div id="coverText">
          <p>个人财富规划报告</p>
          <span>Personal Financial Planning Report</span>
        </div>
      </div>
      <div>
        <img id="coverlogo"
             src="@/assets/images/wpsp/coverlogo.png">
      </div>
    </div>
    <div id="interval"></div>
    <!-- logo -->
    <img id='logo'
         src="@/assets/images/wpsp/logo.png"
         alt="">
    <!-- 页眉 -->
    <div id="header">
      <span></span>
      <span>个人财富规划报告</span>
      <span></span>
    </div>
    <!--step 1  声明-->
    <div class="step1">
      <div class="title1">第一部分 声明</div>
      <div class="Division"></div>
      <p>尊敬的{{one.custName}}{{one.gender==='1'?'先生':'女士'}}: </p>
      <p class="indent">您好！感谢您对{{one.bankName}}的信任。</p>
      <p class="indent">我们的职责是准确评估您的财务需求，
        按照符合您的利益和风险承受能力的原则，
        为您提供高质量的财务建议和长期的金融服务。</p>
      <p class="indent">本理财规划报告是在您提供的资料基础上，
        基于当前的经济环境作出的合理假设，
        综合考虑您的基本家庭信息、财务状况、
        风险承受能力、理财目标等因素所制定的。
        希望通过我们为您提供的理财服务，
        您和您的家庭将进一步提升生活品质，
        并能更加从容潇洒地面对生活，尽早实现财务自由。</p>
      <p class="indent">您所提供信息的完整性、
        真实性将有利于我们为您制定更加完善的理财规划，
        提供更好的理财服务，请您仔细阅读本理财规划，
        以确保信息的准确无误。按照理财从业人员的行为准则，
        我们将对您的家庭资料严格保密。 </p>
      <p class="indent">当您目前的生活状况发生变化时，请及时与我行联系，
        我们将及时对您的理财计划进行调整。 </p>
      <p class="indent"> 如果您有任何理财需求问题，欢迎您致电或亲临我行营业网点，我们将竭诚为您服务!</p>
      <p class="right">{{one.nowTime|conversionDate}} </p>
      <p class="right">客户经理：{{one.userName|prdNameFilterTwo}}</p>
    </div>
    <!-- 页脚 -->
    <div id="footer">
      <span>客户姓名：{{one.custName|prdNameFilterTwo}}</span>
      <span></span>
      <span>客户经理：{{one.userName|prdNameFilterTwo}}</span>
    </div>
    <!--step 2 基本状况介绍-->
    <div class="step2">
      <div class="title1">第二部分 基本状况介绍</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>家庭关系</div>
      <div class="contentOne">
        <div class="relationship">
          <span>姓名：{{two.custName}}</span>
          <span>学历：{{two.education}}</span>
          <span>职业：{{two.occupation}}</span>
          <span>投资经验：{{two.investExperience}}</span>
          <span>投资知识：{{two.investKnowledge}}</span>
        </div>
        <el-table :data="two.customerFamilySupple"
                  stripe
                  style="width: 100% ;font-size: 20px;">
          <el-table-column align="center"
                           prop="custName"
                           label="姓名">
          </el-table-column>
          <el-table-column align="center"
                           prop="custAge"
                           label="年龄">
          </el-table-column>
          <el-table-column align="center"
                           prop="relationship"
                           label="关系">
            <template slot-scope="scope">
              {{ scope.row.custRelation |familyRelationship}}
            </template>
          </el-table-column>
        </el-table>
        <p>在分析您家庭财务状况­和需求的基础上，结合分析您生活和职业特点，我们为您家庭制定了一份详实的理财规划，帮助您更好地规划人生。</p>
        <p>家庭理财就是在金融机构理财顾问的帮助下，通过确定家庭的财务目标，制定财务计划，运用各种理财工具，不断地积累和合理的运用财富，从而实现这些目标的过程。通过家庭理财，您可以降低或控制人生中面临的各类风险，提高生活质量和水平。</p>
        <p>基于您提供的信息，我们通过整理、分析和假设，将您的家庭情况罗列如下。我们将以此为基础开始理财规划。 </p>
        <div v-if="two.custAge<=30">
          <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。都说万事开头难，理财同样如此。单身时期可以说是我们经济压力最小的时期，也是财富积累的起步期。这一时期的理财重点应该放在财富的获取方面。努力工作积累经验，加强工作能力，没有什么比提升自己的赚钱能力更重要的事，这也是今后财富收入的主要来源。多学习理财知识，节省开支，选择本金投入少的理财方式 </p>
        </div>
        <div v-else-if="two.custAge<=40">
          <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。您正当风华正茂之年,说最主要的财务压力来自于建设家庭的费用，包括购房、购车、提升生活品质的物品等等，大多数都是需要长期完成，因此虽然财务压力提升，但是生活毕竟还是比较简单。理财重点大部分放在购置家庭资产方面，最好由两人共同完成生活消费等等，建立家庭账户管理共同财产。整合家庭财产和资产负债，制定家庭理财计划，选择高收益理财产品。同时还有助于培养两人感情和处理问题的能力。 </p>
        </div>
        <div v-else-if="two.custAge<=50">
          <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。您已过不惑之年,说明您的家庭正处于家庭稳定期。处于家庭稳定期的家庭，收入不断提高，支出逐渐稳定，财富也将逐步增加。这一时期要处理好孩子的生活费用和下一阶段上学的费用，开源节流是关键。专门设立一个子女教育金账户，用来购置长期收益稳定并且安全的理财产品，作为今后子女教育资金储备。 </p>
        </div>
        <div v-else-if="two.custAge<=60">
          <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。子女独立之后，家庭压力减轻，这时候工作能力和经济收入达到最高值，需要为自己的养老金做准备。 同时这一时期也是很多老年病的产生期，家庭理财规划要重新调整，准备好应对意外和生病的资金。理财重点放在财富的增值方面，制定养老规划，准备一个养老金账户，投资偏向保守型，可少量配置高风险高回报的投资。 </p>
        </div>
        <div v-else>
          <p> 不同的家庭成长阶段会有不同财富积累方式和不同理财目标。没有了工作的烦恼和子女的压力，这一时期的重点就是安度晚年，有些老年人退休后选择照看第三代，也有人选择旅行、游玩等等，无论怎样的生活方式都要有所节制，不要把辛辛苦苦积攒一辈子的钱都花掉，至少要留给自己足够的生活费和治病费。投资和消费都应该保守，安全稳定是关键，增加养老账户和看病账户的资金比例，尽量选择期限灵活的投资方式，给自己的晚年生活一份保障。</p>
        </div>
      </div>
      <div class="title3"><i class="el-icon-caret-right"></i>风险属性说明</div>
      <div class="contentTwo">
        <p>根据对您的风险属性进行测试，您属于<span>{{two.riskLevel}}</span>投资人。</p>
        <div>
          <span>
            <div class="ArrowShow"
                 v-if="two.riskLevel==='保守型'"><i class="el-icon-caret-bottom"></i>保守型<i class="el-icon-caret-top"></i></div>
            <div class="Arrow"
                 v-if="two.riskLevel!=='保守型'">保守型</div>
          </span>
          <span>
            <div class="ArrowShow"
                 v-if="two.riskLevel==='谨慎型'"><i class="el-icon-caret-bottom"></i>谨慎型<i class="el-icon-caret-top"></i></div>
            <div class="Arrow"
                 v-if="two.riskLevel!=='谨慎型'">谨慎型</div>
          </span>
          <span>
            <div class="ArrowShow"
                 v-if="two.riskLevel==='平衡型'"><i class="el-icon-caret-bottom"></i>平衡型<i class="el-icon-caret-top"></i></div>
            <div class="Arrow"
                 v-if="two.riskLevel!=='平衡型'">平衡型</div>
          </span>
          <span>
            <div class="ArrowShow"
                 v-if="two.riskLevel==='进取型'"><i class="el-icon-caret-bottom"></i>进取型<i class="el-icon-caret-top"></i></div>
            <div class="Arrow"
                 v-if="two.riskLevel!=='进取型'">进取型</div>
          </span>
          <span>
            <div class="ArrowShow"
                 v-if="two.riskLevel==='激进型'"><i class="el-icon-caret-bottom"></i>激进型<i class="el-icon-caret-top"></i></div>
            <div class="Arrow"
                 v-if="two.riskLevel!=='激进型'">激进型</div>
          </span>
        </div>
        <p v-if="two.riskLevel==='保守型'">作为保守型的客户，您基本上不希望承受任何投资风险，因为您不愿承受任何投资损失。含投资成分的金融产品不适合您。</p>
        <p v-if="two.riskLevel==='谨慎型'">作为谨慎型的客户，您基本上接受轻微的损失，以换取轻微的潜在投资回报。适合您的产品的资本价值可能波动。</p>
        <p v-if="two.riskLevel==='平衡型'">作为平衡型的客户，您基本上接受低程度的损失，以换取低程度的潜在投资回报。可能适合您的产品之资本价值可能波动并跌至低于您原本的投资额。</p>
        <p v-if="two.riskLevel==='进取型'">作为进取型的客户，您基本上接受高程度的损失，以换取高程度的潜在投资回报。资本价值可能有相当大幅的波动并跌至颇低于您原本的投资额。</p>
        <p v-if="two.riskLevel==='激进型'">作为激进型的客户，您基本上接受极大的损失，以换取得极大的潜在投资回报。资本价值可能大幅波动并跌至远低于您原本的投资额。</p>
      </div>
    </div>
    <!--step 3 基本假设-->
    <div class="step3">
      <div class="title1">第三部分 基本假设</div>
      <div class="Division"></div>
      <p> 本报告的规划创建时间为 {{Three.nowTime}}，
        由于您的基本信息尚不足够完整以及未来经济
        周期波动可能对本理财方案造成一定影响，
        为便于做出数据详实的理财规划，
        我们基于如下相关数据进行预测和假设:
      </p>
      <el-table :data="Three.paramDeployList"
                stripe
                style="width: 100% ;font-size: 20px;">
        <el-table-column align="center"
                         prop="paramName"
                         label="参数名称"
                         width="180px">
        </el-table-column>
        <el-table-column align="center"
                         prop="paramValue"
                         label="参数值"
                         width="180px">
        </el-table-column>
        <el-table-column align="center"
                         prop="paramExplain"
                         label="参数说明">
        </el-table-column>
        <el-table-column align="center"
                         prop="updateTime"
                         label="更新时间">
        </el-table-column>
      </el-table>
    </div>
    <!--step 4 家庭财务情况与财务诊断-->
    <div class="step4">
      <div class="title1">第四部分 家庭财务情况与财务诊断</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>财务情况</div>
      <p>
        以下是您家庭截止{{Three.nowTime}}的财务情况总结。为了更好的提供金融理财服务，
        请确保以下资产、负债、收入和支出信息是准确的。
      </p>
      <span>家庭收支情况：</span>
      <div class="chart">
        <div style="width:49%">
          <v-chart v-if="this.Four.fourthPage.incomeShow"
                   :options="this.Four.fourthPage.incomeHistogram"
                   style="width:100%;height:200px;"></v-chart>
          <span>家庭年收入：{{this.Four.fourthPage.totalIncome|fmtCustFinanceInfo}}元</span>
          <el-table :data="this.Four.fourthPage.incomeTableData"
                    stripe
                    border
                    show-summary
                    :summary-method="getSummaries"
                    style="width: 100%">
            <el-table-column label="科目"
                             prop="name">
              <template slot-scope="scope">
                {{ scope.row.name}}
              </template>
            </el-table-column>
            <el-table-column label="本人"
                             prop="oneself">
              <template slot-scope="scope">
                {{ scope.row.oneself |fmtCustFinanceInfo}}
              </template>
            </el-table-column>
            <el-table-column label="配偶"
                             prop="spouse"
                             v-if="spouseShow">
              <template slot-scope="scope">
                {{ scope.row.spouse |fmtCustFinanceInfo}}
              </template>
            </el-table-column>
            <el-table-column label="合计"
                             prop="Total">
              <template slot-scope="scope">
                {{ scope.row.Total|fmtCustFinanceInfo}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width:49%">
          <v-chart v-if="this.Four.fourthPage.expenditureShow"
                   :options="this.Four.fourthPage.expenditureHistogram"
                   style="width:100%;height:200px;"></v-chart>
          <span>家庭年支出：{{this.Four.fourthPage.totalExpenditure|fmtCustFinanceInfo}}元</span>
          <el-table :data="this.Four.fourthPage.expenditureTableData"
                    stripe
                    border
                    show-summary
                    :summary-method="getSummaries"
                    style="width: 100%">
            <el-table-column label="科目"
                             prop="name">
              <template slot-scope="scope">
                {{ scope.row.name}}
              </template>
            </el-table-column>
            <el-table-column label="本人"
                             prop="oneself">
              <template slot-scope="scope">
                {{ scope.row.oneself |fmtCustFinanceInfo}}
              </template>
            </el-table-column>
            <el-table-column label="配偶"
                             prop="spouse"
                             v-if="spouseShow">
              <template slot-scope="scope">
                {{ scope.row.spouse |fmtCustFinanceInfo}}
              </template>
            </el-table-column>
            <el-table-column label="合计"
                             prop="Total">
              <template slot-scope="scope">
                {{ scope.row.Total|fmtCustFinanceInfo}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span>家庭资产情况：</span>
      <div class="assets">
        <v-chart v-if="Four.fourthPage.chargeOverviewShow"
                 :options="Four.fourthPage.chargeOverviewData"
                 style="width:400px;height:300px;left:-50px;"></v-chart>
        <el-table :data="Four.fourthPage.assetsTableData"
                  stripe
                  border
                  :span-method="arraySpanMethod"
                  style="width: 100%">
          <el-table-column label="科目"
                           align="center">
            <template slot-scope="scope">
              <span :style="scope.row.name==='合计'?'color:red;':''">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="本人"
                           align="center">
            <el-table-column label="行内"
                             align="center">
              <template slot-scope="scope">
                <span :style="scope.row.name==='合计'?'color:red;':''"> {{ scope.row.within |fmtCustFinanceInfo}}</span>
              </template>
            </el-table-column>
            <el-table-column label="行外"
                             align="center">
              <template slot-scope="scope">
                <span :style="scope.row.name==='合计'?'color:red;':''"> {{ scope.row.external |fmtCustFinanceInfo}}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="配偶"
                           align="center"
                           v-if="spouseShow">
            <el-table-column label="行内"
                             align="center">
              <template slot-scope="scope">
                <span :style="scope.row.name==='合计'?'color:red;':''"> {{ scope.row.spousewithin |fmtCustFinanceInfo}}</span>
              </template>
            </el-table-column>
            <el-table-column label="行外"
                             align="center">
              <template slot-scope="scope">
                <span :style="scope.row.name==='合计'?'color:red;':''"> {{ scope.row.spouseexternal |fmtCustFinanceInfo}}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="合计"
                           align="center">
            <template slot-scope="scope">
              <span :style="scope.row.name==='合计'?'color:red;':''"> {{ (scope.row.within==='-'?0:scope.row.within)+(scope.row.spousewithin==='-'?0:scope.row.spousewithin)+scope.row.external+scope.row.spouseexternal |fmtCustFinanceInfo}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--step 5 第四部分后续内容 财务诊断-->
    <div class="step5">
      <div class="title3"><i class="el-icon-caret-right"></i>财务诊断</div>
      <p> 由于您的财务信息尚不足够完整以及宏观经济周期波动可能对本理财方案造成一定影响，
        为便于您能更全面理解您家庭的财务状况，我们基于您提供的家庭财务情况的相关数据进行如下分析:</p>
      <div>
        <table>
          <tr class="Header">
            <th>指标</th>
            <th>客户情况</th>
            <th>理想数值</th>
            <th>描述</th>
          </tr>
          <tr style="background: rgba(199, 1, 14, 0.1);">
            <th>家庭债务偿还能力</th>
            <th>
              <div>
                <div class="dialogBottom-left"
                     v-show="Four.fifthPage.solvency.ratioOne.ratio == '-1'">
                  <div>
                    <img src="@/assets/images/wpsp/text.png"
                         alt />
                    <span>暂无计算数据</span>
                  </div>
                </div>
                <div class="dialogTop-left"
                     v-show="Four.fifthPage.solvency.ratioOne.ratio != '-1'">
                  <div>
                    <p ref="num">
                      {{
                        Four.fifthPage.solvency.ratioOne.ratio * 100 > 50
                          ? "50"
                          : (Four.fifthPage.solvency.ratioOne.ratio * 100).toFixed(0)
                      }}
                    </p>
                    <img :src="
                        Four.fifthPage.solvency.ratioOne.ratio * 100 < 35
                          ? coordinateSrc.green
                          : coordinateSrc.yellow
                      "
                         alt
                         ref="num1" />
                    <div>&nbsp;</div>
                    <ul>
                      <li>0</li>
                      <li>35</li>
                      <li>50</li>
                    </ul>
                  </div>
                </div>
              </div>
            </th>
            <th>小于35%</th>
            <th>
              <div class="dialogTop-right">
                <p v-if="Four.fifthPage.solvency.ratioOne.ratio == -1">
                  债务偿还比例，反映的是家庭的债务偿还情况，比如我们房贷，车贷等等是否合理。
                </p>
                <p v-else-if="Four.fifthPage.solvency.ratioOne.ratio * 100 >= 35">
                  债务偿还比例，反映的是家庭的债务偿还情况，比如我们房贷，车贷等等是否合理。
                  <span>您的家庭债务偿还比例过高</span>，家庭可能随时面临财务危机，需要减少消费，增加家庭收入。
                </p>
                <p v-else>
                  债务偿还比例，反映的是家庭的债务偿还情况，比如我们房贷，车贷等等是否合理。
                  <span>您的家庭债务偿还比小于35%</span>，这表明您可以很好的偿还您的已有债务，并且稍有余地，请继续保持。
                </p>
              </div>
            </th>
          </tr>
          <tr>
            <th>家庭负债情况</th>
            <th>
              <div class="dialogBottom-left"
                   v-show="Four.fifthPage.solvency.ratioTwo.ratio == '-1'">
                <div>
                  <img src="@/assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="Four.fifthPage.solvency.ratioTwo.ratio != '-1'">
                <div>
                  <p ref="num10">
                    {{
                        Four.fifthPage.solvency.ratioTwo.ratio * 100 > 100
                          ? "100"
                          : (Four.fifthPage.solvency.ratioTwo.ratio * 100).toFixed(0)
                      }}
                  </p>
                  <img :src="
                        Four.fifthPage.solvency.ratioTwo.ratio * 100 < 50
                          ? coordinateSrc.green
                          : coordinateSrc.yellow
                      "
                       alt
                       ref="num11" />
                  <div class="labilities-one">&nbsp;</div>
                  <ul class="labilities-two">
                    <li>0</li>
                    <li>50</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
            </th>
            <th>小于50%</th>
            <th>
              <div class="dialogTop-right">
                <p v-if="Four.fifthPage.solvency.ratioTwo.ratio == -1">
                  负债比率是指家庭用于偿还各种债务支出占家庭当月总收入的百分比。
                </p>
                <p v-else-if="Four.fifthPage.solvency.ratioTwo.ratio * 100 > 50">
                  负债比率是指家庭用于偿还各种债务支出占家庭当月总收入的百分比。
                  <span>您的负债比例过高，超过家庭承受能力</span>
                  ,每月需要付出的利息费将会上升,会在家庭财务发生紧急情况,如失业等情况时,造成财务负担,甚至是“资不抵债”。
                </p>
                <p v-else>
                  负债比率是指家庭用于偿还各种债务支出占家庭当月总收入的百分比。
                  <span>您的负债比例正常，在家庭承受能力范围内</span>,您的家庭债务情况良好，暂时无需为债务担忧。
                </p>
              </div>
            </th>
          </tr>
          <tr style="background: rgba(199, 1, 14, 0.1);">
            <th>家庭财务自由度</th>
            <th>
              <div class="dialogBottom-left"
                   v-show="Four.fifthPage.finance.ratioOne.ratio == '-1'">
                <div>
                  <img src="@/assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="Four.fifthPage.finance.ratioOne.ratio != '-1'">
                <div>
                  <p ref="num8">
                    {{
                        Four.fifthPage.finance.ratioOne.ratio * 100 > 100
                          ? "100"
                          : (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0)
                      }}
                  </p>
                  <img :src="
                        custAge < 30
                          ? Four.fifthPage.finance.ratioOne.ratio * 100 > 5 && Four.fifthPage.finance.ratioOne.ratio * 100 < 15
                            ? coordinateSrc.green
                            : coordinateSrc.yellow
                          : custAge < 40
                          ? Four.fifthPage.finance.ratioOne.ratio * 100 > 15 && Four.fifthPage.finance.ratioOne.ratio * 100 < 30
                            ? coordinateSrc.green
                            : coordinateSrc.yellow
                          : custAge < 50
                          ? Four.fifthPage.finance.ratioOne.ratio * 100 > 30 && Four.fifthPage.finance.ratioOne.ratio * 100 < 50
                            ? coordinateSrc.green
                            : coordinateSrc.yellow
                          : Four.fifthPage.finance.ratioOne.ratio * 100 > 50
                          ? coordinateSrc.green
                          : coordinateSrc.yellow
                      "
                       alt
                       ref="num9" />
                  <div :class="
                        custAge < 30
                          ? 'finance-one-1'
                          : custAge < 40
                          ? 'finance-one-2'
                          : custAge < 50
                          ? 'finance-one-3'
                          : 'finance-one-4'
                      ">
                    &nbsp;
                  </div>
                  <ul class="finance-two">
                    <li>0</li>
                    <li>5</li>
                    <li>15</li>
                    <li>30</li>
                    <li>50</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
            </th>
            <th v-if="custAge>50">50-100%</th>
            <th v-else-if="custAge>40">30-50%</th>
            <th v-else-if="custAge>30">15-30%</th>
            <th v-else>5-15%</th>
            <th>
              <div class="dialogTop-right">
                <p v-if="Four.fifthPage.finance.ratioOne.ratio == -1">
                  财务自由度是指，当您不工作的时候，
                  也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                </p>
                <p v-else-if="custAge < 30 && Four.fifthPage.finance.ratioOne.ratio * 100 > 15">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。

                  <span>通过计算，您的家庭财务自由度为
                    {{
                        (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0)
                      }}%。您已经实现了财务自由， </span>当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="
                      custAge < 30 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 <= 15 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 >= 5
                    ">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。
                </p>
                <p v-else-if="custAge < 30 && Four.fifthPage.finance.ratioOne.ratio * 100 < 5">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>

                <p v-else-if="custAge >= 30 && custAge < 40 && Four.fifthPage.finance.ratioOne.ratio * 100 > 30">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。您已经实现了财务自由，</span>
                  当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="
                      custAge >= 30 &&
                        custAge < 40 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 <= 30 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 >= 15
                    ">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。
                </p>
                <p v-else-if="custAge >= 30 && custAge < 40 && Four.fifthPage.finance.ratioOne.ratio * 100 < 15">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>
                <p v-else-if="custAge >= 40 && custAge < 50 && Four.fifthPage.finance.ratioOne.ratio * 100 > 50">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。

                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。您已经实现了财务自由，</span>
                  当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="
                      custAge >= 40 &&
                        custAge < 50 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 <= 50 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 >= 30
                    ">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。
                </p>
                <p v-else-if="custAge >= 40 && custAge < 50 && Four.fifthPage.finance.ratioOne.ratio * 100 < 30">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>

                <p v-else-if="custAge >= 50 && Four.fifthPage.finance.ratioOne.ratio * 100 >= 100">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。您已经实现了财务自由，</span>
                  当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="
                      custAge >= 50 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 < 100 &&
                        Four.fifthPage.finance.ratioOne.ratio * 100 >= 50
                    ">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。
                </p>
                <p v-else-if="custAge >= 50 && Four.fifthPage.finance.ratioOne.ratio * 100 < 50">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{ (Four.fifthPage.finance.ratioOne.ratio * 100).toFixed(0) }}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>
              </div>
            </th>
          </tr>
          <tr>
            <th>家庭资产变现能力</th>
            <th>
              <div class="dialogBottom-left"
                   v-show="Four.fifthPage.emergency.ratioOne.ratio == '-1'">
                <div>
                  <img src="@/assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="Four.fifthPage.emergency.ratioOne.ratio != '-1'">
                <div>
                  <p ref="num2">
                    {{ Four.fifthPage.emergency.ratioOne.ratio > 9 ? "9" : Four.fifthPage.emergency.ratioOne.ratio }}
                  </p>
                  <img :src="
                        Four.fifthPage.emergency.ratioOne.ratio > 3 && Four.fifthPage.emergency.ratioOne.ratio < 6
                          ? coordinateSrc.green
                          : coordinateSrc.yellow
                      "
                       alt
                       ref="num3" />
                  <div class="assets-one">&nbsp;</div>
                  <ul class="assets-two">
                    <li>0</li>
                    <li>3</li>
                    <li>6</li>
                    <li>9</li>
                  </ul>
                </div>
              </div>
            </th>
            <th>3-6</th>
            <th>
              <div class="dialogTop-right">
                <p v-if="Four.fifthPage.emergency.ratioOne.ratio == -1">
                  流动性比率是指能迅速变现而不会带来损失的资产,
                  比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                </p>
                <p v-else-if="Four.fifthPage.emergency.ratioOne.ratio > 6">
                  流动性比率是指能迅速变现而不会带来损失的资产,比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                  <span>这意味着您家庭的闲置资金较多，不利于资产的保值增值。</span>
                </p>
                <p v-else-if="Four.fifthPage.emergency.ratioOne.ratio >= 3 && Four.fifthPage.emergency.ratioOne.ratio <= 6">
                  流动性比率是指能迅速变现而不会带来损失的资产,比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                  <span>这意味着您家庭的闲置资金处于正常水平，您可以继续保持。</span>
                </p>
                <p v-else>
                  流动性比率是指能迅速变现而不会带来损失的资产,比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                  <span>这意味着家庭可能存在财务危机，</span>一旦家庭成员遇到病重住院等突发事情，不能及时拿出钱应对，家庭抗风险能力较低。
                </p>
              </div>
            </th>
          </tr>
          <tr style="background: rgba(199, 1, 14, 0.1);">
            <th>家庭储蓄能力</th>
            <th>
              <div class="dialogBottom-left"
                   v-show="Four.fifthPage.emergency.ratioTwo.ratio == '-1'">
                <div>
                  <img src="@/assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="Four.fifthPage.emergency.ratioTwo.ratio != '-1'">
                <div>
                  <p ref="num4">
                    {{
                        Four.fifthPage.emergency.ratioTwo.ratio * 100 > 100
                          ? "100"
                          : (Four.fifthPage.emergency.ratioTwo.ratio * 100).toFixed(0)
                      }}
                  </p>
                  <img :src="
                        Four.fifthPage.emergency.ratioTwo.ratio * 100 > 40 && Four.fifthPage.emergency.ratioTwo.ratio * 100 < 60
                          ? coordinateSrc.green
                          : coordinateSrc.yellow
                      "
                       alt
                       ref="bum5" />
                  <div class="savings-one">&nbsp;</div>
                  <ul class="savings-two">
                    <li>0</li>
                    <li>40</li>
                    <li>60</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
            </th>
            <th>40-60%</th>
            <th>
              <div class="dialogTop-right">
                <p v-if="Four.fifthPage.emergency.ratioTwo.ratio == -1">
                  储蓄率，是家庭可支配收入中储蓄的占比，
                  反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                </p>
                <p v-else-if="Four.fifthPage.emergency.ratioTwo.ratio * 100 < 40">
                  储蓄率，是家庭可支配收入中储蓄的占比，反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭储蓄率低于40%，</span>这说明家庭的开支较多，没能进行很好的储蓄积累。建议对家庭资产开支进行有效规划，做好储蓄和花费之间的平衡。
                </p>
                <p v-else-if="
                      Four.fifthPage.emergency.ratioTwo.ratio * 100 >= 40 && Four.fifthPage.emergency.ratioTwo.ratio * 100 <= 60
                    ">
                  储蓄率，是家庭可支配收入中储蓄的占比，反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率处于正常水平，请继续保持</span>
                </p>
                <p v-else>
                  储蓄率，是家庭可支配收入中储蓄的占比，反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭储蓄率超过60%，</span>
                  通过储蓄虽然可以积累财富，但进行合理的消费可以显著的提高生活水平，建议对家庭开支进行有效规划，做好储蓄和花费之间的平衡。
                </p>
              </div>
            </th>
          </tr>
          <tr>
            <th>家庭消费能力</th>
            <th>
              <div class="dialogBottom-left"
                   v-show="Four.fifthPage.emergency.ratioThree.ratio == '-1'">
                <div>
                  <img src="@/assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="Four.fifthPage.emergency.ratioThree.ratio != '-1'">
                <div>
                  <p ref="num6">
                    {{
                        Four.fifthPage.emergency.ratioThree.ratio * 100 > 100
                          ? "100"
                          : (Four.fifthPage.emergency.ratioThree.ratio * 100).toFixed(0)
                      }}
                  </p>
                  <img :src="
                        Four.fifthPage.emergency.ratioThree.ratio * 100 > 40 &&
                        Four.fifthPage.emergency.ratioThree.ratio * 100 < 60
                          ? coordinateSrc.green
                          : coordinateSrc.yellow
                      "
                       alt
                       ref="num7" />
                  <div class="savings-one">&nbsp;</div>
                  <ul class="savings-two">
                    <li>0</li>
                    <li>40</li>
                    <li>60</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
            </th>
            <th>40-60%</th>
            <th>
              <div class="dialogTop-right">
                <p v-if="Four.fifthPage.emergency.ratioThree.ratio == -1">
                  消费比例，是家庭消费支出/家庭收入，
                  反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                </p>
                <p v-else-if="Four.fifthPage.emergency.ratioThree.ratio * 100 < 40">
                  消费比例，是家庭消费支出/家庭收入，反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率低于40%，</span>
                  这说明家庭的开支较少，虽能存下很多钱，但是之后家庭的生活质量和品质被降低了。
                  消费比例一定要合理，过低、过高都会影响到我们的生活。
                </p>
                <p v-else-if="
                      Four.fifthPage.emergency.ratioThree.ratio * 100 >= 40 &&
                        Four.fifthPage.emergency.ratioThree.ratio * 100 <= 60
                    ">
                  消费比例，是家庭消费支出/家庭收入，反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率处于正常水平，请继续保持。</span>
                </p>
                <p v-else>
                  消费比例，是家庭消费支出/家庭收入，反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率超过60%，</span>这说明家庭的储蓄能力不强，不利于家庭积累更多的财富。
                </p>
              </div>
            </th>
          </tr>
        </table>
      </div>
    </div>
    <!--step 6 子女教育-->
    <div v-if="childrenWhether"
         class="step6">
      <div class="title1">第五部分 子女教育</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>客户概览</div>
      <div>
        <ul>
          <li>
            • 您当前<span v-if="overviewList.childCountResult === 0">您当前暂无子女需要完成学业</span>
            <span v-else>有{{ overviewList.childCountResult }}个子女需要进行教育规划， 距离{{ overviewList.childCountResult > 1 ? "他们" : overviewList.childRelation === "4" ? "他" : "她" }}毕业最长还有{{ overviewList.maxYears }}年。 在未来的学习生涯中，将会产生学费{{ overviewList.eduAndLiveExpenseMap.schoolCostTotal | addMoneyFilter }}元， 生活费{{ overviewList.eduAndLiveExpenseMap.lifeCostTotal | addMoneyFilter }}元。</span>
          </li>
          <li>• 您当前已为子女准备了教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 计划未来每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元， 期望教育储备金每年能产生{{ overviewList.getReserveInfo.expectedRevenue*100 | addMoneyFilter }}%的收益。</li>
          <li v-if="overviewList.riskLevel !== ''">
            • 当前子女教育规划基于{{overviewList.planTime}}时您的信息生成， 您的风险等级为{{ overviewList.riskLevel }}。
          </li>
        </ul>
        <div class="bottomPart">
          <span v-for="(v, i) in childrenList"
                :key="i"
                class="children">
            {{ v.custName }}
            <br />
            <span v-if="v.currentClass !== 20">
              • 当前处于{{ v.currentClass | childrenFilters }}，距离毕业还有{{ v.graduationYear }}年
              <br />
              • 此间将产生学费{{ v.childCostInfoList[0].moneyTotal | addMoneyFilter }}元，生活费{{ v.childCostInfoList[1].moneyTotal | addMoneyFilter }}元
            </span>
            <span v-else>• 当前子女{{ v.currentClass | childrenFilters }}。</span>
          </span>
        </div>
      </div>
      <div class="title3"><i class="el-icon-caret-right"></i>测算分析</div>
      <div class="content">
        <ul>
          <li>
            <p v-if="overviewList.getMeasureReserve.irr === '无法达成规划'">
              1.根据您已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元，则
              <span class="red">{{ overviewList.getMeasureReserve.irr }}</span>
            </p>
            <p v-else-if="overviewList.getMeasureReserve.irr > '0'">
              1.根据您已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元， 则至少需要达到年化<span class="red">{{ (overviewList.getMeasureReserve.irr*1).toFixed(2) }}%</span>的投资收益， 才能满足您的规划需求。
            </p>
            <p v-else>根据您已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元，<span class="red"> 则目前您储备情况已能满足子女教育需求</span>。</p>
          </li>
          <li>
            <p>
              2.根据您每月储蓄{{ overviewList.getReserveInfo.monthMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ overviewList.getReserveInfo.expectedRevenue*100|addMoneyFilter }}%， 则当前的子女教育储备金<span class="red">
                <span v-if="overviewList.getMeasureReserve.reserveGap === '0'">存在资金缺口</span>
                <span v-else>资金富余</span>
                {{ overviewList.getMeasureReserve.reserveBreach | addMoneyFilter }}元 </span>。
            </p>
          </li>
          <li>
            <p>
              3.根据您已存教育储备金{{ overviewList.getReserveInfo.currentMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ overviewList.getReserveInfo.expectedRevenue*100|addMoneyFilter }}%，
              <span v-if="overviewList.getMeasureReserve.monthGap !== 2">
                则每月投入的子女教育储备金
                <span class="red">
                  <span v-if="overviewList.getMeasureReserve.monthGap === '0'">存在资金缺口</span>
                  <span v-else>资金富余</span>
                  {{ overviewList.getMeasureReserve.monthBreach | addMoneyFilter }}元
                </span></span><span v-else
                    class="red"> {{ overviewList.getMeasureReserve.monthBreach }}</span>。
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!--生涯仿真图-->
    <div v-if="childrenWhether"
         class="Careersimulation">
      <div class="title3"><i class="el-icon-caret-right"></i>生涯仿真</div>
      <v-chart :options="option"
               v-if="highChartsShow"
               style="width:100%;height:500px;"></v-chart>
    </div>
    <!--step 7 子女教育后续 可行性分析-->
    <div v-if="childrenWhether"
         class="step7">
      <div class="title3"><i class="el-icon-caret-right"></i>可行性分析</div>
      <p>
        根据测算，基于客户提供的数据在不进行干预下实现整体规划的可能性为<span>{{ meterDataMsg }}%</span>
      </p>
      <div class="chart">
        <v-chart :options="meterData"
                 v-show="meterDataShow"
                 style="width:400px;height:400px; position: relative;margin: 0 auto"></v-chart>
        <v-chart :options="monteCarloData"
                 v-if="monteCarloDataShow"></v-chart>
      </div>
      <p>本次方案的可行性分析与实现可能性是系统基于蒙特卡洛模拟
        这一分析方法计算得来。 蒙特卡洛模拟是一种数据统计方法，
        我们会通过多达100000次的模拟测试， 在每一次模拟中随机
        生成客户在未来规划生涯中每一年可能的投资收益， 来模拟客
        户可能的资产变化情况。通过观察统计在这100000次模拟中客
        户资产可以完全覆盖子女教育消费支出的情景个数， 来计算得
        出客户实现整体方案规划的实现可能性。</p>
      <p>需要注意，本次模拟中涉及到的投资收益是我们依据客户当
        前的风险等级，并通过分析统计市场上同类型客户投资收益情
        况综合所得，力求能最大程度的还原真实的投资环境所进行的
        模拟测试。其模拟结果并不代表真实投资收益。通过计算得出
        的方案实现可能性结果仅供此次方案测算参考，并不代表未来
        实际情况。</p>
      <div class="title3"><i class="el-icon-caret-right"></i>方案描述</div>
      <div>1.方案描述</div>
      <p style="word-wrap: break-word;">{{ programmeText }}</p>
      <div>
        <div>2.产品列表</div>
        <span v-if="tableDataOne.length!==0">理财</span>
        <br />
        <el-table :data="tableDataOne"
                  :header-cell-style="{ background: '#F5F7FA' }"
                  style="width: 100%;"
                  v-if="tableDataOne.length!==0">
          <el-table-column prop="prdCode"
                           label="产品代码"> </el-table-column>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              {{ scope.row.prdName |prdNameFilterTwo}}
            </template>
          </el-table-column>
          <el-table-column prop="investTerm"
                           label="投资期限（天）"> </el-table-column>
          <el-table-column prop="performanceCriterion"
                           label="业绩比较基准"> </el-table-column>
          <el-table-column prop="riskLevelRes"
                           label="风险等级"> </el-table-column>
          <el-table-column label="购买金额（元）">
            <template slot-scope="scope">
              {{ scope.row.purchasedMoney | addMoneyFilter }}
            </template>
          </el-table-column>
        </el-table>
        <br />
        <span class="Title-three"
              v-if="tableDataTwo.length!==0">大额存单</span>
        <el-table :data="tableDataTwo"
                  :header-cell-style="{ background: '#F5F7FA' }"
                  style="width: 100%;"
                  v-if="tableDataTwo.length!==0">
          <el-table-column prop="prdCode"
                           label="产品代码"> </el-table-column>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              {{ scope.row.prdName |prdNameFilterTwo}}
            </template>
          </el-table-column>
          <el-table-column prop="prdStatusRes"
                           label="起存金额（元）">
            <template slot-scope="scope">
              {{ scope.row.purchaseAmounts | addMoneyFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="sellStatusRes"
                           label="存单期限">
            <template slot-scope="scope">
              {{ scope.row.termLimit  }}
            </template>
          </el-table-column>
          <el-table-column prop="topFlagRes"
                           label="年利率">
            <template slot-scope="scope"> {{ scope.row.annualInsrate }}% </template>
          </el-table-column>
          <el-table-column label="购买金额（元）">
            <template slot-scope="scope">
              {{ scope.row.purchasedMoney | addMoneyFilter }}
            </template>
          </el-table-column>
        </el-table>
        <br />
      </div>
    </div>

    <!--step 8 养老规划-->
    <div v-if="pensionWhether"
         class="step8">
      <div class="title1">第{{childrenWhether===false?'五':'六'}}部分 养老规划</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>客户概览</div>
      <div>
        <ul>
          <li>
            • 您目前<span>{{planPensionInfo.self.age }}岁</span>，<span>{{planPensionInfo.self.age>planPensionInfo.self.retirementAge?'已':'预计'}}</span>于<span>{{planPensionInfo.self.retirementAge }}岁</span>退休<span v-if="planPensionInfo.self.pensionSource !='1'"
                  style="color:black;">，退休后每月可领取社保养老金<span>{{ planPensionInfo.self.socialSecurityPension | addMoneyFilter}}元</span> </span>。
            <span v-if="planPensionInfo.spouse"
                  style="color:black;">您配偶目前<span>{{ planPensionInfo.spouse.age }}岁</span>，<span>{{planPensionInfo.spouse.age>planPensionInfo.spouse.retirementAge?'已':'预计'}}</span>于
              <span>{{ planPensionInfo.spouse.retirementAge }}岁</span>退休 <span v-if="planPensionInfo.spouse.pensionSource !='1' "
                    style="color:black;">，退休后每月可领取社保养老金
                <span>{{planPensionInfo.spouse.socialSecurityPension | addMoneyFilter}}元</span> </span>。
            </span>
          </li>
          <li>• 您家庭每月日常开支为<span>{{planPensionInfo.length!==2?planPensionInfo.self.monthExpend+planPensionInfo.spouse.monthExpend:planPensionInfo.self.monthExpend | addMoneyFilter}}元</span>。目前已存家庭养老金<span>{{overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.currentMoney | addMoneyFilter}}元</span>，计划未来每月储蓄<span>{{overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.monthMoney | addMoneyFilter}}元</span>，期望补充养老金每年能产生<span>{{overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.expectedRevenue*100|addMoneyFilter}}%</span>的收益。</li>
          <li v-if="overviewListTwo.riskLevel !== ''">
            • 当前退休养老规划基于{{overviewListTwo.planTime}}时您的信息生成，您的风险等级为{{ overviewListTwo.riskLevel }}。
          </li>
        </ul>
      </div>
      <div class="title3"><i class="el-icon-caret-right"></i>测算分析</div>
      <div class="content">
        <ul>
          <li>
            <p>
              1.根据您已存家庭养老金{{ overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.currentMoney | addMoneyFilter }}元， 且计划每月储蓄{{ overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.monthMoney | addMoneyFilter }}元，
              <span class="red"
                    v-if="!(overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.irr*1>0)">{{ overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.irr }}</span>
              <span v-else>则至少需要达到年化<span class="red">{{ overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.irr }}</span>%的投资收益，才能满足客户的规划需求</span>
            </p>
          </li>
          <li>
            <p>
              2.根据您每月储蓄{{ overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.monthMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.expectedRevenue*100|addMoneyFilter}}%， 则当前的家庭养老金
              <span class="red">
                <span v-if="overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.reserveGap=='1'">资金富余</span>
                <span v-else>存在资金缺口</span>
                {{ overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.reserveBreach | addMoneyFilter }}元
              </span>。
            </p>
          </li>
          <li>
            <p>
              3.根据您已存家庭养老金{{ overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.currentMoney | addMoneyFilter }}元， 且每年能达成期望投资收益{{ overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve.expectedRevenue *100|addMoneyFilter}}%，
              则每月投入的家庭养老金
              <span class="red">
                <span v-if="overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.monthGap=='1'">资金富余</span>
                <span v-else>存在资金缺口</span>
                {{ overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult.monthBreach | addMoneyFilter }}元
              </span>。
            </p>
          </li>
        </ul>
      </div>
      <div class="title3"><i class="el-icon-caret-right"></i>生涯仿真</div>
      <v-chart :options="optionPension"
               v-if="highChartsShowPension"
               style="width:100%;height:500px;"></v-chart>
    </div>
    <!--step 9 养老规划后续 可行性分析-->
    <div v-if="pensionWhether"
         class="step9">
      <div class="title3"><i class="el-icon-caret-right"></i>可行性分析</div>
      <p>
        根据测算，基于客户提供的数据在不进行干预下实现整体规划的可能性为<span>{{ meterDataMsgPension }}%</span>
      </p>
      <div class="chart">
        <v-chart :options="meterDataPension"
                 v-show="meterDataShowPension"
                 style="width:400px;height:400px; position: relative;margin: 0 auto"></v-chart>
        <v-chart :options="monteCarloDataPension"
                 v-if="monteCarloDataShowPension"></v-chart>
      </div>
      <p>本次方案的可行性分析与实现可能性是系统基于蒙特卡洛模拟
        这一分析方法计算得来。 蒙特卡洛模拟是一种数据统计方法，
        我们会通过多达100000次的模拟测试， 在每一次模拟中随机
        生成客户在未来规划生涯中每一年可能的投资收益， 来模拟客
        户可能的资产变化情况。通过观察统计在这100000次模拟中客
        户资产可以完全覆盖子女教育消费支出的情景个数， 来计算得
        出客户实现整体方案规划的实现可能性。</p>
      <p>需要注意，本次模拟中涉及到的投资收益是我们依据客户当
        前的风险等级，并通过分析统计市场上同类型客户投资收益情
        况综合所得，力求能最大程度的还原真实的投资环境所进行的
        模拟测试。其模拟结果并不代表真实投资收益。通过计算得出
        的方案实现可能性结果仅供此次方案测算参考，并不代表未来
        实际情况。</p>
      <div class="title3"><i class="el-icon-caret-right"></i>方案描述</div>
      <div>1.方案描述</div>
      <p style="word-wrap:break-word;">{{ programmeTextPension }}</p>
      <div>
        <div>2.产品列表</div>
        <span v-if="tableDataOnePension.length!==0">理财</span>
        <br />
        <el-table :data="tableDataOnePension"
                  :header-cell-style="{ background: '#F5F7FA' }"
                  style="width: 100%;"
                  v-if="tableDataOnePension.length!==0">
          <el-table-column prop="prdCode"
                           label="产品代码"> </el-table-column>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              {{ scope.row.prdName |prdNameFilterTwo}}
            </template>
          </el-table-column>
          <el-table-column prop="investTerm"
                           label="投资期限（天）"> </el-table-column>
          <el-table-column prop="performanceCriterion"
                           label="业绩比较基准"> </el-table-column>
          <el-table-column prop="riskLevelRes"
                           label="风险等级"> </el-table-column>
          <el-table-column label="购买金额（元）">
            <template slot-scope="scope">
              {{ scope.row.purchasedMoney | addMoneyFilter }}
            </template>
          </el-table-column>
        </el-table>
        <br />
        <span class="Title-three"
              v-if="tableDataTwoPension.length!==0">大额存单</span>
        <el-table :data="tableDataTwoPension"
                  :header-cell-style="{ background: '#F5F7FA' }"
                  style="width: 100%;"
                  v-if="tableDataTwoPension.length!==0">
          <el-table-column prop="prdCode"
                           label="产品代码"> </el-table-column>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              {{ scope.row.prdName|prdNameFilterTwo }}
            </template>
          </el-table-column>
          <el-table-column prop="prdStatusRes"
                           label="起存金额（元）">
            <template slot-scope="scope">
              {{ scope.row.purchaseAmounts | addMoneyFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="sellStatusRes"
                           label="存单期限">
            <template slot-scope="scope">
              {{ scope.row.termLimit  }}
            </template>
          </el-table-column>
          <el-table-column prop="topFlagRes"
                           label="年利率">
            <template slot-scope="scope"> {{ scope.row.annualInsrate }}% </template>
          </el-table-column>
          <el-table-column label="购买金额（元）">
            <template slot-scope="scope">
              {{ scope.row.purchasedMoney | addMoneyFilter }}
            </template>
          </el-table-column>
        </el-table>
        <br />
      </div>
    </div>

    <!--step 10 产品配置-->
    <div class="step10"
         v-if="pensionWhether||childrenWhether">
      <div class="title1">第{{childrenWhether===false||pensionWhether===false?'六':'七'}}部分 产品配置</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>方案描述：</div>
      <div class="title2"
           v-if="childrenWhether">子女教育方案描述：</div>
      <p style="word-wrap:break-word;"
         v-if="childrenWhether">{{childrenText}}</p>
      <div class="title2"
           v-if="pensionWhether">退休养老方案描述：</div>
      <p style="word-wrap:break-word;"
         v-if="pensionWhether">{{pensionText}}</p>
      <div class="title3"><i class="el-icon-caret-right"></i>推荐产品：</div>
      <div class="title4"
           v-if="listTableDataOne.length!==0">理财：</div>
      <el-table :data="listTableDataOne"
                :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%;"
                v-if="listTableDataOne.length!==0">
        <el-table-column label="产品代码">
          <template slot-scope="scope">
            {{ scope.row.prdCode  }}
          </template>
        </el-table-column>
        <el-table-column label="产品名称">
          <template slot-scope="scope">
            {{ scope.row.prdName  |prdNameFilterTwo}}
          </template>
        </el-table-column>
        <el-table-column label="业绩比较基准">
          <template slot-scope="scope">
            {{ scope.row.performanceCriterion  }}
          </template>
        </el-table-column>
        <el-table-column label="投资期限">
          <template slot-scope="scope">
            {{ scope.row.investTerm  }}
          </template>
        </el-table-column>
        <el-table-column label="起购金额（元）">
          <template slot-scope="scope">
            {{ scope.row.purchaseAmounts  |addMoneyFilter}}
          </template>
        </el-table-column>
        <el-table-column label="关联规划">
          <template slot-scope="scope">
            <span>{{ scope.row.planType[0]  }}</span>
            <br>
            <span>{{ scope.row.planType[1]  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="建议购买金额(元)">
          <template slot-scope="scope">
            <span> {{ scope.row.oneMoney[0]   |addMoneyFilter}}</span>
            <br>
            <span> {{ scope.row.oneMoney[1]   |addMoneyFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="合计建议金额(元)">
          <template slot-scope="scope">
            {{ scope.row.allMoney   |addMoneyFilter}}
          </template>
        </el-table-column>
      </el-table>
      <br>
      <div class="title4"
           v-if="listTableDataTwo.length!==0">大额存单：</div>
      <el-table :data="listTableDataTwo"
                :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%;"
                v-if="listTableDataTwo.length!==0">
        <el-table-column label="产品代码">
          <template slot-scope="scope">
            {{ scope.row.prdCode  }}
          </template>
        </el-table-column>
        <el-table-column label="产品名称">
          <template slot-scope="scope">
            {{ scope.row.prdName  |prdNameFilterTwo}}
          </template>
        </el-table-column>
        <el-table-column label="年利率（%）">
          <template slot-scope="scope">
            {{ scope.row.annualInsrate  }}
          </template>
        </el-table-column>
        <el-table-column label="存单期限">
          <template slot-scope="scope">
            {{ scope.row.termLimit }}
          </template>
        </el-table-column>
        <el-table-column label="起存金额">
          <template slot-scope="scope">
            {{ scope.row.purchaseAmounts   |addMoneyFilter}}
          </template>
        </el-table-column>
        <el-table-column label="关联规划">
          <template slot-scope="scope">
            <span>{{ scope.row.planType[0]  }}</span>
            <br>
            <span>{{ scope.row.planType[1]  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="建议购买金额(元)">
          <template slot-scope="scope">
            <span> {{ scope.row.oneMoney[0]   |addMoneyFilter}}</span>
            <br>
            <span> {{ scope.row.oneMoney[1]  |addMoneyFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合计建议金额(元)">
          <template slot-scope="scope">
            {{ scope.row.allMoney   |addMoneyFilter}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--step 11 风险告知与定期审视-->
    <div class="step11">
      <div class="title1">第{{childrenWhether===false&&pensionWhether===false?'五':childrenWhether===false||pensionWhether===false?'七':'八'}}部分 风险告知与定期审视</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>风险告知</div>
      <p>1.该理财方案是基于根据目前的市场情况作出
        的一些假设制定出来的，这些假设会随着国家经济的变化而发生
        变化，比如:物价水平会不断变化，证券市场的波动，经济增长率
        的变 化，汇率的变动，国家的房地产调控政策等等，这些都会对
        理财方案会产生一定的影响。</p>
      <p>2. 生活支出除了受到物价水平的因素影响之外，还要考虑未来
        生活品质的提高、医疗、保健等 方面的支出，这些支出的需求将
        会不断增加，会影响到其他目标的实现。</p>
      <p> 3. 孩子的教育支出也可能会超出预期的增长，国内外的学费水
        平不断上涨，也会对理财方案产生一定的影响。</p>
      <p>4. 客户在执行本方案时，应该遵循客户经理的意见，客户经理会
        定期与客户对方案进行调整，如果客户单方面修改或不遵照执行，
        也会产生一定的风险。</p>
      <div class="title3"><i class="el-icon-caret-right"></i>定期审视</div>
      <p>1. 个人综合理财规划报告方案要定期(一般为一年)审视并作出评估和调整，
        以便使个人综合理财规划报告方案更加符合实际。</p>
      <p> 2. 客户如果发生重大变化，应当及时通知客户经理，
        对个人综合理财规划报告及时作出调整。</p>
      <p>3. 客户经理也应当将一些理财信息和投资信息及时告知客户，
        以便使客户作出合理的判断。</p>
    </div>
    <!--step 10 免责条款-->
    <div class="step12">
      <div class="title1">第{{childrenWhether===false&&pensionWhether===false?'六':childrenWhether===false||pensionWhether===false?'八':'九'}}部分 免责条款</div>
      <div class="Division"></div>
      <div class="title3"><i class="el-icon-caret-right"></i>免责条款</div>
      <p>1. 本个人综合理财规划报告是为协助您理清财务需求
        及目标而设计的，使您能在充分的信息下做理财决策。
        本策划是依据您所提供的资料及若干一般可接受的假设，
        再加上合理的预估来推算结果。这是免费提供给您的非义
        务服务。 </p>
      <p>2. 本个人综合理财规划报告仅在您决策如何以最佳方式达
        成财务目标时用作指导。本个人综合理财规划报告无意取代
        财务咨询或规划服务。如果您有与财务相关的问题，应请教
        合格的财务顾问。所有的计算及假设都是基于您目前的财务
        状况及现今的经济环境而来。这两者都是会产生变化的。本
        人建议您定期审视您的财务目标和规划，特别是当您的婚姻
        状况改变或家庭成员增加时更需如此。</p>
      <p>3. 投资产品并非存款，本人对其不负有义务或承担保证或
        保险责任，并且这些投资产品存在投资 风险，其中包括可能
        损失投入本金在内。过去的绩效并不说明未来的绩效，价格
        可能上扬或下跌。 </p>
      <p>4. 本个人综合理财规划报告所得的结果是基于您所提供的
        信息及假设得来的。您所提供的信息越精准，越 有助于评估
        的结果。本个人综合理财规划报告仅用作指导，不能代替专业
        的税务、法务建议。</p>
      <p> 5. 由于地震、火灾、战争等其他各种不可抗力因素引起的
        经济损失国工商银行不承担任何经济和法律责任。</p>
      <p> 6. 本免责条款的最终解释权属{{one.bankName}}。</p>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas';
import pdf from 'vue-pdf';
import jsPDF from 'jspdf';
import { Loading } from 'element-ui';
// eslint-disable-next-line import/no-unresolved
import greenCoordinate from '@/assets/images/wpsp/greenCoordinate.png';
// eslint-disable-next-line import/no-unresolved
import yellowCoordinate from '@/assets/images/wpsp/yellowCoordinate.png';
import depositDetailDialog from '../../../components/wpsp/productPlan/depositDetailDialog.vue';
import financeDetailDialog from '../../../components/wpsp/productPlan/financeDetailDialog.vue';

export default {
  name: 'conclusion',
  components: {
    financeDetailDialog,
    depositDetailDialog,
    pdf,
  },
  watch: {
    curStep (val) {
      if (val === 12) {
        this.$emit('assembly', this.pdfBase64);
      }
    },
  },
  data () {
    return {
      pdf: new jsPDF('', 'pt', 'a4'),
      pdfSrc: '',
      pdfBase64: '',
      // 当前生成pdf第几页
      curStep: 1,
      // 第一页数据
      one: {},
      // 第二页数据
      two: {},
      // 是否有配偶
      spouseShow: false,
      // 第三部分
      Three: {},
      // 第四部分
      Four: {
        fourthPage: {
          // 总年收入
          totalIncome: '',
          incomeShow: false,
          // 年收入柱状图数据
          incomeHistogram: {},
          // 年收入表格数据
          incomeTableData: [
            {
              name: '工资收入',
              oneself: 0,
              spouse: 0,
              Total: 0,
            },
            {
              name: '金融投资收益',
              oneself: 0,
              spouse: 0,
              Total: 0,
            },
            {
              name: '其他收入',
              oneself: 0,
              spouse: 0,
              Total: 0,
            },
          ],
          // 总年支出
          totalExpenditure: '',
          expenditureShow: false,
          // 年支出柱状图数据
          expenditureHistogram: {},
          // 年支出表格数据
          expenditureTableData: [
            {
              name: '日常支出',
              oneself: 0,
              spouse: 0,
              Total: 0,
            },
            {
              name: '贷款及利息支出',
              oneself: 0,
              spouse: 0,
              Total: 0,
            },
            {
              name: '其他支出',
              oneself: 0,
              spouse: 0,
              Total: 0,
            },
          ],
          chargeOverviewShow: false,
          // 饼图数据
          chargeOverviewData: {},

          // 家庭资产表格数据
          assetsTableData: [
            {
              name: '现金及活存',
              within: 0, // 行内
              external: 0, // 行外
              spousewithin: 0, // 配偶行内
              spouseexternal: 0, // 配偶行外
            },
            {
              name: '定期存款',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
            {
              name: '债券',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
            {
              name: '基金',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
            {
              name: '理财',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
            {
              name: '贵金属',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
            {
              name: '其他',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
            {
              name: '合计',
              within: 0,
              external: 0,
              spousewithin: 0,
              spouseexternal: 0,
            },
          ],
        },
        fifthPage: {
          // 家庭偿债能力
          solvency: { ratioOne: { ratio: '-1' }, ratioTwo: { ratio: '-1' } },
          // 家庭应急能力
          emergency: {
            ratioOne: { ratio: '-1' },
            ratioTwo: { ratio: '-1' },
            ratioThree: { ratio: '-1' },
          },
          // 家庭财务自由
          finance: { ratioOne: { ratio: '-1' } },
        },
      },
      custAge: JSON.parse(sessionStorage.getItem('custInfo')).custAge, // 客户年龄
      // 第五部分 子女教育
      // 是否有子女教育规划
      childrenWhether: false,
      // 客户概览数据集合
      overviewList: {
        childCountResult: '',
        childRelation: '',
        maxYears: '',
        riskLevel: '',
        eduAndLiveExpenseMap: {
          sumEduExpense: '',
          sumLiveExpense: '',
        },
        getReserveInfo: {
          currentMoney: '',
          monthMoney: '',
          expectedRevenue: '',
        },
        getMeasureReserve: {
          irr: '',
          reserveBreach: '',
          monthBreach: '',
        },
      },
      // 每个子女信息
      childrenList: [],
      // 现金流分析图参数
      id: 'test',
      option: {},
      highChartsShow: false,
      coordinateSrc: {
        green: greenCoordinate,
        yellow: yellowCoordinate,
      },
      // 财务分析html2canvas的数据
      Analysisimg: '',
      Analysisw: '',
      Analysish: '',
      // 可行性分析仪表盘数据
      meterData: {},
      meterDataMsg: '',
      meterDataShow: '',
      // 蒙特卡洛分析图数据
      monteCarloData: {},
      monteCarloDataShow: false,
      // 子女产品方案描述文字
      programmeText: '',
      // 理财产品列表数据
      tableDataOne: [],
      // 大额存单产品列表数据
      tableDataTwo: [],

      // 第六部分 养老
      // 是否有养老规划
      pensionWhether: false,
      // 本人及配偶信息
      planPensionInfo: {
        self: {},
        spouse: {},
      },
      // 客户概览数据集合
      overviewListTwo: {
        riskLevel: '', // 风险等级
        planPensionInfos: [],
        pensionIrrAndBreachMap: {
          pensionPlanReserve: {
            currentMoney: '', // 已存家庭养老金
            monthMoney: '', // 每月投入的养老金
            expectedRevenue: '', // 期望收益
          },
          pensionBreachResult: {
            monthGap: '', // 每月缺口标记：0缺口，1富余
            pensionBreach: '', // 缺口养老金
            pensionGap: '', // 缺口标记：0缺口，1富余
            pensionMonthBreach: '', // 养老月缺口
          },
        },
      },
      // 生涯仿真
      optionPension: {},
      highChartsShowPension: false,
      // 可行性分析仪表盘数据
      meterDataPension: {},
      meterDataMsgPension: '',
      meterDataShowPension: false,
      // 蒙特卡洛分析图数据
      monteCarloDataPension: {},
      monteCarloDataShowPension: false,

      // 养老产品方案描述文字
      programmeTextPension: '',
      // 理财产品列表数据
      tableDataOnePension: [],
      // 大额存单产品列表数据
      tableDataTwoPension: [],

      // 产品配置
      // 子女
      childrenText: '',
      // 养老
      pensionText: '',
      // 理财产品配置列表
      listTableDataOne: [],
      // 大额存单产品配置列表
      listTableDataTwo: [],
    };
  },
  filters: {
    // 子女状态过滤器
    childrenFilters (v) {
      // eslint-disable-next-line no-unused-vars
      let i = '';
      switch (v) {
        case 0:
          i = '学龄前';
          break;
        case 1:
          i = '幼儿园小班';
          break;
        case 2:
          i = '幼儿园中班';
          break;
        case 3:
          i = '幼儿园大班';
          break;
        case 4:
          i = '小学一年级';
          break;
        case 5:
          i = '小学二年级';
          break;
        case 6:
          i = '小学三年级';
          break;
        case 7:
          i = '小学四年级';
          break;
        case 8:
          i = '小学五年级';
          break;
        case 9:
          i = '小学六年级';
          break;
        case 10:
          i = '初中一年级';
          break;
        case 11:
          i = '初中二年级';
          break;
        case 12:
          i = '初中三年级';
          break;
        case 13:
          i = '高中一年级';
          break;
        case 14:
          i = '高中二年级';
          break;
        case 15:
          i = '高中三年级';
          break;
        case 16:
          i = '大学一年级';
          break;
        case 17:
          i = '大学二年级';
          break;
        case 18:
          i = '大学三年级';
          break;
        case 19:
          i = '大学四年级';
          break;
        case 20:
          i = '已毕业';
          break;
        default:
          break;
      }
      return i;
    },
    // 日期转换
    conversionDate (v) {
      if (v !== undefined) {
        return v.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1年$2月$3日');
      }
      return '';
    },

    // 家庭关系过滤器
    familyRelationship (v) {
      let i = '';
      switch (v) {
        case '0':
          i = '本人';
          break;
        case '1':
          i = '配偶';
          break;
        case '2':
          i = '父亲';
          break;
        case '3':
          i = '母亲';
          break;
        case '4':
          i = '儿子';
          break;
        case '5':
          i = '女儿';
          break;
        case '6':
          i = '配偶父亲';
          break;
        case '7':
          i = '配偶母亲';
          break;
        default:
          break;
      }
      return i;
    },
    prdNameFilterTwo (value) {
      if (value !== undefined) {
        if (value.length > 7) {
          return `${value.slice(0, 7)}...`;
        }
        return value;
      }
      return '';
    },
    termLimitFilter (x) {
      if (x === '' || x === null || x === undefined) {
        return '-';
      }
      if (x === '1') {
        return '1个月';
      }
      if (x === '2') {
        return '3个月';
      }
      if (x === '3') {
        return '6个月';
      }
      if (x === '4') {
        return '9个月';
      }
      if (x === '5') {
        return '1年';
      }
      if (x === '6') {
        return '18个月';
      }
      if (x === '7') {
        return '2年';
      }
      if (x === '8') {
        return '3年';
      }
      if (x === '9') {
        return '5年';
      }
      return '-';
    },
  },
  mounted () {
    this.presentationAll();
  },
  methods: {
    async presentationAll () {
      const loading = this.$loading({
        lock: true,
        text: '正在玩命生成',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setInterval(() => {
        this.$emit('failureGeneration', loading);
      }, 60000);
      const custInfo = JSON.parse(sessionStorage.getItem('custInfo'));
      const sessionData = JSON.parse(sessionStorage.getItem('userDetailData')) !== null
        ? JSON.parse(sessionStorage.getItem('userDetailData'))
        : JSON.parse(sessionStorage.getItem('sessionData'));
      const parames = {
        data: {
          cis: custInfo.cis,
          bankName: '中国工商银行',
          userName: sessionData.userName,
          createUserid: sessionData.userCode,
        },
      };
      this.$_post(this.$API.presentationAll, parames)
        .then((res) => {
          const dataList = res.data;
          // 第一页
          this.one = dataList.firstPage;
          // 第二页
          this.two = dataList.secondPage;
          for (let i = 0; i < this.two.customerFamilySupple.length; i++) {
            if (this.two.customerFamilySupple[i].custRelation === '1') {
              this.spouseShow = true;
            }
          }
          // 第三部分
          this.Three = dataList.thirdPage;
          // 第四部分
          this.financeDataEncapsulation(dataList.fourthPage);
          this.Four.fifthPage.solvency = dataList.fifthPage.list[0]; // 财务分析数据
          this.Four.fifthPage.emergency = dataList.fifthPage.list[1]; // 财务分析数据
          this.Four.fifthPage.finance = dataList.fifthPage.list[2]; // 财务分析数据
          this.offset();
          // 第五部分 子女教育
          if (dataList.sixthPage !== undefined) {
            this.childrenWhether = true;
            this.overviewList.childCountResult = dataList.sixthPage.childCount;
            this.overviewList.childRelation = dataList.sixthPage.childList[0].custRelation;
            this.overviewList.eduAndLiveExpenseMap = dataList.sixthPage.childTotalCostInfo;
            this.overviewList.getReserveInfo = dataList.sixthPage.planInfo.planReserve;
            this.overviewList.maxYears = dataList.sixthPage.maxYear;
            this.overviewList.riskLevel = dataList.sixthPage.planInfo.riskLevel;
            this.overviewList.planTime = dataList.sixthPage.planInfo.planTime;
            this.childrenList = dataList.sixthPage.childList;
            this.overviewList.getMeasureReserve = dataList.sixthPage.planInfo.getMeasureReserve;
            this.cashFlowImgFn(dataList.sixthPage.planInfo, 1);
            this.meterData = this.meterDataFn(
              dataList.sixthPage.planInfo.ratio,
              1,
            );
            this.monteCarloData = this.monteCarloDataFn(
              dataList.sixthPage.planInfo,
              1,
            );
            this.programmeText = dataList.sixthPage.schemeDescriptionChildren.replace(
              /<.*?>/gi,
              '',
            );
            for (
              let i = 0;
              i < dataList.sixthPage.selectedProductListChildren.length;
              i++
            ) {
              if (
                dataList.sixthPage.selectedProductListChildren[i].prdType
                === '1'
              ) {
                this.tableDataOne.push(
                  dataList.sixthPage.selectedProductListChildren[i],
                );
              } else if (
                dataList.sixthPage.selectedProductListChildren[i].prdType
                === '2'
              ) {
                this.tableDataTwo.push(
                  dataList.sixthPage.selectedProductListChildren[i],
                );
              }
            }
          }
          // 第六部分 养老
          if (dataList.seventhPage !== null) {
            this.pensionWhether = true;
            console.log(dataList.seventhPage.planPensionInfoList[0]);
            if (dataList.seventhPage.planPensionInfoList.length === 1) {
              this.planPensionInfo.self = dataList.seventhPage.planPensionInfoList[0];
            } else {
              this.planPensionInfo.self = dataList.seventhPage.planPensionInfoList[0];
              this.planPensionInfo.spouse = dataList.seventhPage.planPensionInfoList[1];
            }
            this.overviewListTwo.pensionIrrAndBreachMap.pensionPlanReserve = dataList.seventhPage.planInfo.planReserve;
            this.overviewListTwo.riskLevel = dataList.seventhPage.planInfo.riskLevel;
            this.overviewListTwo.planTime = dataList.seventhPage.planInfo.planTime;
            this.overviewListTwo.pensionIrrAndBreachMap.pensionBreachResult = dataList.seventhPage.planInfo.getMeasureReserve;
            this.cashFlowImgFn(dataList.seventhPage.planInfo, 2);
            this.meterDataPension = this.meterDataFn(
              dataList.seventhPage.planInfo.ratio,
              2,
            );
            this.monteCarloDataPension = this.monteCarloDataFn(
              dataList.seventhPage.planInfo,
              2,
            );
            this.programmeTextPension = dataList.seventhPage.schemeDescriptionPension.replace(
              /<.*?>/gi,
              '',
            );
            for (
              let i = 0;
              i < dataList.seventhPage.selectedProductListPension.length;
              i++
            ) {
              if (
                dataList.seventhPage.selectedProductListPension[i].prdType
                === '1'
              ) {
                this.tableDataOnePension.push(
                  dataList.seventhPage.selectedProductListPension[i],
                );
              } else if (
                dataList.seventhPage.selectedProductListPension[i].prdType
                === '2'
              ) {
                this.tableDataTwoPension.push(
                  dataList.seventhPage.selectedProductListPension[i],
                );
              }
            }
          }
          // 产品配置
          if (dataList.eighthPage !== null) {
            this.childrenText = dataList.eighthPage.childrenSchemDescription.replace(
              /<.*?>/gi,
              '',
            );
            this.pensionText = dataList.eighthPage.presionSchemDescription.replace(
              /<.*?>/gi,
              '',
            );
            for (
              let i = 0;
              i < dataList.eighthPage.selectedProductListAll.length;
              i++
            ) {
              if (
                dataList.eighthPage.selectedProductListAll[i].prdType === '1'
              ) {
                this.listTableDataOne.push(
                  dataList.eighthPage.selectedProductListAll[i],
                );
              } else {
                this.listTableDataTwo.push(
                  dataList.eighthPage.selectedProductListAll[i],
                );
              }
            }
            for (let i = 0; i < this.listTableDataOne.length; i++) {
              this.listTableDataOne[i].planType = this.listTableDataOne[
                i
              ].planType.split(',');
              this.listTableDataOne[i].oneMoney = this.listTableDataOne[
                i
              ].oneMoney.split(',');
            }
            console.log(this.listTableDataOne[0].oneMoney[1]);
            for (let i = 0; i < this.listTableDataTwo.length; i++) {
              this.listTableDataTwo[i].planType = this.listTableDataTwo[
                i
              ].planType.split(',');
              this.listTableDataTwo[i].oneMoney = this.listTableDataTwo[
                i
              ].oneMoney.split(',');
            }
          }
          setTimeout(() => {
            this.preview(loading);
          }, 3000);
        })
        .catch((res) => {
          loading.close();
          this.$emit('assemblyThree');
        });
    },
    // 第四部分财务情况数据组装
    financeDataEncapsulation (v) {
      this.Four.fourthPage.totalIncome = v.customerIncomeSum.incomeTotal; // 总收入
      const arr = [
        v.customerIncomeSum.otherIncomeTotal / 10000,
        v.customerIncomeSum.investIncomeTotal / 10000,
        v.customerIncomeSum.salaryIncomeTotal / 10000,
      ]; // 图表单位为万
      // 家庭收入柱状图
      this.histogramAssignment(arr, 1);
      console.log(arr, '家庭收入柱状图数据');
      this.Four.fourthPage.incomeShow = true;
      // 家庭收入表格
      for (let i = 0; i < v.customerIncomeInfos.length; i++) {
        if (v.customerIncomeInfos[i].isSelf === '0') {
          for (
            let x = 0;
            x < this.Four.fourthPage.incomeTableData.length;
            x++
          ) {
            if (this.Four.fourthPage.incomeTableData[x].name === '工资收入') {
              this.Four.fourthPage.incomeTableData[x].oneself = v.customerIncomeInfos[i].salaryIncome;
            } else if (
              this.Four.fourthPage.incomeTableData[x].name === '金融投资收益'
            ) {
              this.Four.fourthPage.incomeTableData[x].oneself = v.customerIncomeInfos[i].investIncome;
            } else if (
              this.Four.fourthPage.incomeTableData[x].name === '其他收入'
            ) {
              this.Four.fourthPage.incomeTableData[x].oneself = v.customerIncomeInfos[i].otherIncome;
            }
          }
        } else {
          for (
            let x = 0;
            x < this.Four.fourthPage.incomeTableData.length;
            x++
          ) {
            if (this.Four.fourthPage.incomeTableData[x].name === '工资收入') {
              this.Four.fourthPage.incomeTableData[x].spouse = v.customerIncomeInfos[i].salaryIncome;
              this.Four.fourthPage.incomeTableData[x].Total = this.Four.fourthPage.incomeTableData[x].oneself
                + this.Four.fourthPage.incomeTableData[x].spouse;
            } else if (
              this.Four.fourthPage.incomeTableData[x].name === '金融投资收益'
            ) {
              this.Four.fourthPage.incomeTableData[x].spouse = v.customerIncomeInfos[i].investIncome;
              this.Four.fourthPage.incomeTableData[x].Total = this.Four.fourthPage.incomeTableData[x].oneself
                + this.Four.fourthPage.incomeTableData[x].spouse;
            } else if (
              this.Four.fourthPage.incomeTableData[x].name === '其他收入'
            ) {
              this.Four.fourthPage.incomeTableData[x].spouse = v.customerIncomeInfos[i].otherIncome;
              this.Four.fourthPage.incomeTableData[x].Total = this.Four.fourthPage.incomeTableData[x].oneself
                + this.Four.fourthPage.incomeTableData[x].spouse;
            }
          }
        }
      }
      this.Four.fourthPage.totalExpenditure = v.customerExpendSum.expendTotal; // 总支出
      const arrTwo = [
        v.customerExpendSum.otherExpendTotal / 10000,
        v.customerExpendSum.loanInterestExpendTotal / 10000,
        v.customerExpendSum.dailyExpendTotal / 10000,
      ];
      // 家庭支出柱状图
      this.histogramAssignment(arrTwo, 2);
      this.Four.fourthPage.expenditureShow = true;
      // 家庭支出表格
      for (let i = 0; i < v.customerExpendInfos.length; i++) {
        if (v.customerExpendInfos[i].isSelf === '0') {
          for (
            let x = 0;
            x < this.Four.fourthPage.expenditureTableData.length;
            x++
          ) {
            if (
              this.Four.fourthPage.expenditureTableData[x].name === '日常支出'
            ) {
              this.Four.fourthPage.expenditureTableData[x].oneself = v.customerExpendInfos[i].dailyExpend;
            } else if (
              this.Four.fourthPage.expenditureTableData[x].name
              === '贷款及利息支出'
            ) {
              this.Four.fourthPage.expenditureTableData[x].oneself = v.customerExpendInfos[i].loanInterestExpend;
            } else if (
              this.Four.fourthPage.expenditureTableData[x].name === '其他支出'
            ) {
              this.Four.fourthPage.expenditureTableData[x].oneself = v.customerExpendInfos[i].otherExpend;
            }
          }
        } else {
          for (
            let x = 0;
            x < this.Four.fourthPage.expenditureTableData.length;
            x++
          ) {
            if (
              this.Four.fourthPage.expenditureTableData[x].name === '日常支出'
            ) {
              this.Four.fourthPage.expenditureTableData[x].spouse = v.customerExpendInfos[i].dailyExpend;
              this.Four.fourthPage.expenditureTableData[x].Total = this.Four.fourthPage.expenditureTableData[x].oneself
                + this.Four.fourthPage.expenditureTableData[x].spouse;
            } else if (
              this.Four.fourthPage.expenditureTableData[x].name
              === '贷款及利息支出'
            ) {
              this.Four.fourthPage.expenditureTableData[x].spouse = v.customerExpendInfos[i].loanInterestExpend;
              this.Four.fourthPage.expenditureTableData[x].Total = this.Four.fourthPage.expenditureTableData[x].oneself
                + this.Four.fourthPage.expenditureTableData[x].spouse;
            } else if (
              this.Four.fourthPage.expenditureTableData[x].name === '其他支出'
            ) {
              this.Four.fourthPage.expenditureTableData[x].spouse = v.customerExpendInfos[i].otherExpend;
              this.Four.fourthPage.expenditureTableData[x].Total = this.Four.fourthPage.expenditureTableData[x].oneself
                + this.Four.fourthPage.expenditureTableData[x].spouse;
            }
          }
        }
      }
      // 家庭资产情况饼图
      const arrThree = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        legend: {
          width: '300px',
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: [
            '现金及活存',
            '定期活存',
            '债券',
            '基金',
            '理财',
            '贵金属',
            '其他',
          ],
        },
        series: [
          {
            label: { normal: { position: 'inner', formatter: '{d}%' } },
            name: '家庭资产：',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: v.customerFinanceSum.cashTotal,
                name: '现金及活存',
              },
              {
                value: v.customerFinanceSum.depositTotal,
                name: '定期活存',
              },
              {
                value: v.customerFinanceSum.bondTotal,
                name: '债券',
              },
              {
                value: v.customerFinanceSum.fundTotal,
                name: '基金',
              },
              {
                value: v.customerFinanceSum.financeTotal,
                name: '理财',
              },
              {
                value: v.customerFinanceSum.preciousMetalTotal,
                name: '贵金属',
              },
              {
                value: v.customerFinanceSum.otherMoneyTotal,
                name: '其他',
              },
            ],
          },
        ],
      };
      this.Four.fourthPage.chargeOverviewData = arrThree;
      this.Four.fourthPage.chargeOverviewShow = true;
      // 家庭资产情况表格
      for (let i = 0; i < v.customerFinanceInfos.length; i++) {
        if (v.customerFinanceInfos[i].isSelf === '0') {
          if (v.customerFinanceInfos[i].isBank === '0') {
            for (
              let y = 0;
              y < this.Four.fourthPage.assetsTableData.length;
              y++
            ) {
              if (
                this.Four.fourthPage.assetsTableData[y].name === '现金及活存'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = v.customerFinanceInfos[i].cash;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '定期存款'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = '-';
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '债券'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = '-';
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '基金'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = v.customerFinanceInfos[i].fund;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '理财'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = v.customerFinanceInfos[i].finance;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '贵金属'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = '-';
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '其他'
              ) {
                this.Four.fourthPage.assetsTableData[y].within = '-';
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '合计'
              ) {
                this.Four.fourthPage.assetsTableData[y].within
                  += v.customerFinanceInfos[i].fund
                  + v.customerFinanceInfos[i].finance;
              }
            }
          } else {
            for (
              let y = 0;
              y < this.Four.fourthPage.assetsTableData.length;
              y++
            ) {
              if (
                this.Four.fourthPage.assetsTableData[y].name === '现金及活存'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].cash;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '定期存款'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].deposit;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '债券'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].bond;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '基金'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].fund;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '理财'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].finance;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '贵金属'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].preciousMetal;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '其他'
              ) {
                this.Four.fourthPage.assetsTableData[y].external = v.customerFinanceInfos[i].otherMoney;
              } else if (
                this.Four.fourthPage.assetsTableData[y].name === '合计'
              ) {
                this.Four.fourthPage.assetsTableData[y].within
                  += v.customerFinanceInfos[i].cash
                  + v.customerFinanceInfos[i].deposit
                  + v.customerFinanceInfos[i].bond
                  + v.customerFinanceInfos[i].fund
                  + v.customerFinanceInfos[i].finance
                  + v.customerFinanceInfos[i].otherMoney
                  + v.customerFinanceInfos[i].preciousMetal;
              }
            }
          }
        } else if (v.customerFinanceInfos[i].isBank === '0') {
          for (
            let y = 0;
            y < this.Four.fourthPage.assetsTableData.length;
            y++
          ) {
            if (this.Four.fourthPage.assetsTableData[y].name === '现金及活存') {
              this.Four.fourthPage.assetsTableData[y].spousewithin = v.customerFinanceInfos[i].cash;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '定期存款'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin = '-';
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '债券'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin = '-';
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '基金'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin = v.customerFinanceInfos[i].fund;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '理财'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin = v.customerFinanceInfos[i].finance;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '贵金属'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin = '-';
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '其他'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin = '-';
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '合计'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin
                += v.customerFinanceInfos[i].fund
                + v.customerFinanceInfos[i].finance;
            }
          }
        } else {
          for (
            let y = 0;
            y < this.Four.fourthPage.assetsTableData.length;
            y++
          ) {
            if (this.Four.fourthPage.assetsTableData[y].name === '现金及活存') {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].cash;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '定期存款'
            ) {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].deposit;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '债券'
            ) {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].bond;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '基金'
            ) {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].fund;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '理财'
            ) {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].finance;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '贵金属'
            ) {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].preciousMetal;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '其他'
            ) {
              this.Four.fourthPage.assetsTableData[y].spouseexternal = v.customerFinanceInfos[i].otherMoney;
            } else if (
              this.Four.fourthPage.assetsTableData[y].name === '合计'
            ) {
              this.Four.fourthPage.assetsTableData[y].spousewithin
                += v.customerFinanceInfos[i].cash
                + v.customerFinanceInfos[i].deposit
                + v.customerFinanceInfos[i].bond
                + v.customerFinanceInfos[i].fund
                + v.customerFinanceInfos[i].finance
                + v.customerFinanceInfos[i].otherMoney
                + v.customerFinanceInfos[i].preciousMetal;
            }
          }
        }
      }
    },
    // 柱状图赋值
    histogramAssignment (v, i) {
      // v是展示的值，i为1是年收入，2为年支出
      let arr = {};
      if (i === 1) {
        arr = {
          title: {
            text: '',
            subtext: '',
          },
          tooltip: {},
          grid: {
            left: '3%',
            right: '10%',
            bottom: '3%',
            containLabel: true,
          },

          xAxis: {
            name: '(万元)',
            type: 'value',
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            type: 'category',
            data: ['其他收入', '金融投资收益', '工资收入'],
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: v,
              itemStyle: {
                normal: {
                  color: '#C7010E',
                },
              },
            },
          ],
        };
        this.Four.fourthPage.incomeHistogram = arr;
      } else {
        arr = {
          title: {
            text: '',
            subtext: '',
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            left: '3%',
            right: '10%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            name: '(万元)',
            type: 'value',
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            type: 'category',
            data: ['其他支出', '贷款及利息支出', '日常支出'],
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: v,
              itemStyle: {
                normal: {
                  color: 'rgba(134, 131, 131, 1)',
                },
              },
            },
          ],
        };
        this.Four.fourthPage.expenditureHistogram = arr;
      }
    },
    // 生涯仿真图
    cashFlowImgFn (chartsData, v) {
      // chartsData是数据，v用来判断是子女（1）还是养老（2）
      if (v === 1) {
        const arr = [
          {
            name: '总资产',
            data: chartsData.totalCostList,
            type: 'line',
            symbol: 'none',
          },
        ];
        this.option = {
          credits: {
            enabled: false, // 不显示LOGO
          },
          chart: {
            type: 'column',
          },
          title: {
            text: '',
          },
          tooltip: {
            text: '',
          },
          legend: {
            data: ['总资产'],
          },
          xAxis: {
            data: chartsData.yearList,
            // 隐藏刻度
            axisTick: {
              show: false,
            },
            // 隐藏坐标轴
            axisLine: {
              show: false,
            },
            axisLabel: {
              rotate: 40,
              // formatter(value) { //竖文本
              //   return value.split('').join('\n');
              // },
              // margin: 10,
              interval: 'auto',
              showMinLabel: true,
              showMaxLabel: true,
            },
          },
          yAxis: {
            title: '',
            stackLabels: {
              enabled: true,
              style: {
                color: 'red',
              },
            },
          },
          series: arr,
        };
        this.highChartsShow = true;
      } else {
        const arr = [
          {
            name: '总资产',
            data: chartsData.totalCostList,
            type: 'line',
            symbol: 'none',
          },
        ];
        this.optionPension = {
          credits: {
            enabled: false, // 不显示LOGO
          },
          chart: {
            type: 'column',
          },
          title: {
            text: '',
          },
          tooltip: {
            text: '',
          },
          legend: {
            data: ['总资产'],
          },
          xAxis: {
            data: chartsData.yearList,
            // 隐藏刻度
            axisTick: {
              show: false,
            },
            // 隐藏坐标轴
            axisLine: {
              show: false,
            },
            axisLabel: {
              rotate: 40,
              // formatter(value) { //竖文本
              //   return value.split('').join('\n');
              // },
              // margin: 10,
              interval: 'auto',
              showMinLabel: true,
              showMaxLabel: true,
            },
          },
          yAxis: {
            title: '',
            stackLabels: {
              enabled: true,
              style: {
                color: 'red',
              },
            },
          },
          series: arr,
        };
        this.highChartsShowPension = true;
      }
    },
    // 财务分析计算偏移量
    offset () {
      // 偿债能力线段轴偏移量（打开财务分析默认选中第一个tab所以在这里计算）
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num.style.left = this.Four.fifthPage.solvency.ratioOne.ratio * 100 < 50
        ? this.Four.fifthPage.solvency.ratioOne.ratio === 0
          ? '-6%'
          : `${this.Four.fifthPage.solvency.ratioOne.ratio * 100 * 2 - 6}%`
        : '94%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num1.style.left = this.Four.fifthPage.solvency.ratioOne.ratio * 100 < 50
        ? this.Four.fifthPage.solvency.ratioOne.ratio === 0
          ? '-3.5%'
          : `${this.Four.fifthPage.solvency.ratioOne.ratio * 100 * 2 - 4}%`
        : '96.5%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num10.style.left = this.Four.fifthPage.solvency.ratioTwo.ratio * 100 < 100
        ? this.Four.fifthPage.solvency.ratioTwo.ratio === 0
          ? '-6%'
          : `${this.Four.fifthPage.solvency.ratioTwo.ratio * 100 - 6}%`
        : '94%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num11.style.left = this.Four.fifthPage.solvency.ratioTwo.ratio * 100 < 100
        ? this.Four.fifthPage.solvency.ratioTwo.ratio === 0
          ? '-3.5%'
          : `${this.Four.fifthPage.solvency.ratioTwo.ratio * 100 - 4}%`
        : '96.5%';
      // 计算家庭应急能力线段轴的偏移量
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num2.style.left = this.Four.fifthPage.emergency.ratioOne.ratio < 9
        ? this.Four.fifthPage.emergency.ratioOne.ratio === 0
          ? '-6%'
          : `${(this.Four.fifthPage.emergency.ratioOne.ratio / 9) * 100 - 6}%`
        : '94%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num3.style.left = this.Four.fifthPage.emergency.ratioOne.ratio < 9
        ? this.Four.fifthPage.emergency.ratioOne.ratio === 0
          ? '-3.5%'
          : `${(this.Four.fifthPage.emergency.ratioOne.ratio / 9) * 100
          - 3.5}%`
        : '96.5%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num4.style.left = this.Four.fifthPage.emergency.ratioTwo.ratio * 100 < 100
        ? this.Four.fifthPage.emergency.ratioTwo.ratio === 0
          ? '-6%'
          : `${this.Four.fifthPage.emergency.ratioTwo.ratio * 100 - 6}%`
        : '94%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.bum5.style.left = this.Four.fifthPage.emergency.ratioTwo.ratio * 100 < 100
        ? this.Four.fifthPage.emergency.ratioTwo.ratio === 0
          ? '-3.5%'
          : `${this.Four.fifthPage.emergency.ratioTwo.ratio * 100 - 3.5}%`
        : '96.5%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num6.style.left = this.Four.fifthPage.emergency.ratioThree.ratio * 100 < 100
        ? this.Four.fifthPage.emergency.ratioThree.ratio === 0
          ? '-6%'
          : `${this.Four.fifthPage.emergency.ratioThree.ratio * 100 - 6}%`
        : '94%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num7.style.left = this.Four.fifthPage.emergency.ratioThree.ratio * 100 < 100
        ? this.Four.fifthPage.emergency.ratioThree.ratio === 0
          ? '-3.5%'
          : `${this.Four.fifthPage.emergency.ratioThree.ratio * 100 - 3.5}%`
        : '96.5%';
      // 财务自由度线段轴偏移量
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num8.style.left = this.Four.fifthPage.finance.ratioOne.ratio * 100 < 100
        ? this.Four.fifthPage.finance.ratioOne.ratio === 0
          ? '-6%'
          : `${this.Four.fifthPage.finance.ratioOne.ratio * 100 - 6}%`
        : '94%';
      // eslint-disable-next-line no-nested-ternary
      this.$refs.num9.style.left = this.Four.fifthPage.finance.ratioOne.ratio * 100 < 100
        ? this.Four.fifthPage.finance.ratioOne.ratio === 0
          ? '-3.5%'
          : `${this.Four.fifthPage.finance.ratioOne.ratio * 100 - 4}%`
        : '96.5%';
      setTimeout(() => {
        this.Analysishtml2canvas();
      }, 1000);
    },
    // 财务分析内容太多，提前处理好
    Analysishtml2canvas () {
      // 页眉
      html2canvas(document.querySelector('.step5')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // html页面生成的canvas在pdf中图片的宽高
        this.Analysisw = 595.28;
        this.Analysish = (841.89 / contentWidth) * contentHeight - 150;
        this.Analysisimg = canvas.toDataURL('image/jpeg', 1.0);
      });
    },
    // 仪表盘组装数据
    meterDataFn (v, i) {
      // i=1(子女) i=2（养老）
      let msg = v * 100;
      msg = msg.toFixed(2);
      const bar = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        series: [
          {
            name: '2019-02-12 任务分析',
            type: 'gauge',
            detail: { formatter: '{value}%' },
            axisLine: {
              show: true,
              lineStyle: {
                width: 30,
                shadowBlur: 0,
                color: [
                  [0.2, '#FF6A70'],
                  [0.8, '#FFA100'],
                  [1, '#00CD87'],
                ],
              },
            },
            data: [{ value: msg, name: '可行性' }],
          },
        ],
      };
      if (i === 1) {
        this.meterDataMsg = msg;
        this.meterDataShow = true;
      } else {
        this.meterDataMsgPension = msg;
        this.meterDataShowPension = true;
      }

      return bar;
    },
    // 蒙特卡洛分析图数据组装方法
    monteCarloDataFn (v, i) {
      const arr = [];
      const yearsArr = v.yearList;
      if (v.ratio * 1 === 0) {
        arr.middleList = v.successList;
        arr.fail = v.failList;
      } else {
        arr.success = v.successList;
        arr.middleList = v.middleList;
        arr.fail = v.failList;
      }

      console.log(v);
      let colorLine = '';
      let colorLineTwo = '#FFA100';
      if (v.ratio * 1 !== 1 && v.ratio * 1 !== 0) {
        colorLine = '#FFA100';
        colorLineTwo = '#BAC6C8';
      } else if (v.ratio * 1 !== 0) {
        colorLine = '#02BB6F';
      } else if (v.ratio * 1 !== 1) {
        colorLine = '#FFA100';
        colorLineTwo = '#FFA100';
      }
      const seriesArr = [
        {
          name: '成功',
          type: 'line',
          color: '#02BB6F',
          areaStyle: {
            normal: { origin: 'start', color: '#00CD87', opacity: 1 },
          },
          data: arr.success,
        },
        {
          name: v.ratio * 1 !== 1 ? '' : '失败',
          type: 'line',
          color: colorLineTwo,
          areaStyle: {
            normal: { origin: 'start', color: '#FFE2B2', opacity: 1 },
          },
          data: arr.middleList,
        },
        {
          name: v.ratio * 1 !== 1 ? '失败' : '',
          type: 'line',
          color: colorLine,
          areaStyle: {
            normal: { origin: 'start', color: '#fff', opacity: 1 },
          },
          data: arr.fail,
        },
      ];
      if (i === 1) {
        this.monteCarloDataShow = true;
      } else {
        this.monteCarloDataShowPension = true;
      }
      return {
        title: {
          text: '金额(元)',
          top: '5%',
          textStyle: {
            fontWeight: 400,
            fontSize: 14,
          },
        },
        // tooltip: {},
        legend: {
          selectedMode: false,
          data: ['成功', '失败'],
        },

        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: yearsArr,
            // 隐藏刻度
            axisTick: {
              show: false,
            },
            // 隐藏坐标轴
            axisLine: {
              show: false,
            },
            axisLabel: {
              rotate: 40,
              // formatter(value) { //竖文本
              //   return value.split('').join('\n');
              // },
              // margin: 10,
              interval: 'auto',
              showMinLabel: true,
              showMaxLabel: true,
            },
          },
        ],
        yAxis: [
          {
            offset: 1,
            type: 'value',
            splitLine: false,
          },
        ],
        series: seriesArr,
      };
    },
    // 主要的
    async preview (loading) {
      /**
       * 财富报告分开截图的块
       * 1.第一部分 声明
       * 2.第二部分 基本状况介绍
       * 3.第三部分 基本假设
       * 4.第四部分 家庭财务情况与财务诊断
       * 5.第四部分 家庭财务情况与财务诊断后续财务诊断（已提前处理好了，不需要再处理一遍）
       * 6.第五部分 子女教育
       * 7.第五部分 子女教育后续可行性分析
       * 8.第六部分 养老规划
       * 9.第六部分 养老规划后续可行性分析
       * 10.第六部分 产品配置
       * 11.第七部分 风险告知与定期审视
       * 12.第八部分 免责条款
       */
      const steps = [1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12];
      // 页数
      let curStep = 1;
      // a4的宽高
      const a4Width = 595.28;
      const a4height = 841.89;
      // 页面偏移
      let position = 40;
      // 用来判断生涯仿真图是否需要换页
      let judge = true;
      let headerimg = '';
      let headerw = '';
      let headerh = '';
      let footerimg = '';
      let footerw = '';
      let footerh = '';
      let intervalimg = '';
      let intervalw = '';
      let intervalh = '';
      let coverTextimg = '';
      let coverTextw = '';
      let coverTexth = '';
      let Careersimulationimg = '';
      let Careersimulationw = '';
      let Careersimulationh = '';
      const logoImg = document.getElementById('logo');
      const logoimg = this.getImageBase64(logoImg, 'png');
      const homeImg = document.getElementById('homeImg');
      const homebase64 = this.getImageBase64(homeImg, 'png');
      const coverlogo = document.getElementById('coverlogo');
      const coverlogobase64 = this.getImageBase64(coverlogo, 'png');
      // 页眉
      await html2canvas(document.querySelector('#header')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // html页面生成的canvas在pdf中图片的宽高
        headerw = a4Width;
        headerh = (a4Width / contentWidth) * contentHeight;
        headerimg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 页脚
      await html2canvas(document.querySelector('#footer')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // html页面生成的canvas在pdf中图片的宽高
        footerw = a4Width;
        footerh = (a4Width / contentWidth) * contentHeight;
        footerimg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 留白
      await html2canvas(document.querySelector('#interval')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // html页面生成的canvas在pdf中图片的宽高
        intervalw = a4Width;
        intervalh = (a4Width / contentWidth) * contentHeight;
        intervalimg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 生涯仿真
      await html2canvas(document.querySelector('.Careersimulation')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // html页面生成的canvas在pdf中图片的宽高
        Careersimulationw = a4Width;
        Careersimulationh = (a4Width / contentWidth) * contentHeight;
        Careersimulationimg = canvas.toDataURL('image/jpeg', 1.0);
      });
      // 封面内容
      await html2canvas(document.querySelector('#coverText')).then((canvas) => {
        // 画布宽度
        const contentWidth = canvas.width;
        // 画布高度
        const contentHeight = canvas.height;
        // html页面生成的canvas在pdf中图片的宽高
        coverTextw = a4Width;
        coverTexth = (a4Width / contentWidth) * contentHeight;
        coverTextimg = canvas.toDataURL('image/jpeg', 1.0);
        // 封面
        this.pdf.addImage(
          homebase64,
          'JPEG',
          (a4Width - 520) / 2,
          40,
          520,
          520,
        );
        this.pdf.addImage(
          coverTextimg,
          'JPEG',
          (a4Width - 520) / 2,
          520 + coverTexth,
          coverTextw,
          coverTexth,
        );
        this.pdf.addImage(
          coverlogobase64,
          'JPEG',
          a4Width - 150 - (a4Width - 520) / 2,
          a4height - 40,
          150,
          20,
        );
        this.pdf.addPage();
      });
      await steps.forEach((index) => {
        // 每个step为一页
        html2canvas(document.querySelector(`.step${index}`), {
          useCORS: true,
          allowTaint: true,
        }).then((canvas) => {
          // 画布宽度
          const contentWidth = canvas.width;
          // 画布高度
          const contentHeight = canvas.height;
          // 一页pdf显示html页面生成的canvas高度
          const pageHeight = (contentWidth / a4Width) * a4height
            - position
            - headerh
            - footerh
            - intervalh;
          // html实际高度
          let htmlHeight = contentHeight;
          // html页面生成的canvas在pdf中图片的宽高
          const imgWidth = a4Width;
          const imgHeight = (a4Width / contentWidth) * contentHeight;
          // 将画布转为图片数据流
          const pageData = canvas.toDataURL('image/jpeg', 1.0);
          // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          // 当内容未超过pdf一页显示的范围，无需分页
          if (htmlHeight < pageHeight && judge) {
            if (index === 4) {
              // 内容
              this.pdf.addImage(
                pageData,
                'JPEG',
                0,
                position,
                imgWidth,
                imgHeight,
              );
              // 页眉
              this.pdf.addImage(headerimg, 'JPEG', 0, 0, headerw, headerh);
              // 银行logo
              this.pdf.addImage(logoimg, 'JPEG', 30, 10, 59, 20);
              // 页脚
              this.pdf.addImage(
                footerimg,
                'JPEG',
                0,
                a4height - footerh,
                footerw,
                footerh,
              );
              // 页码
              this.pdf.setFontSize(10);
              this.pdf.setTextColor(150);
              this.pdf.text(297.64, 831.89, `-${curStep}-`);
              this.pdf.addPage();
              this.pdf.addImage(
                this.Analysisimg,
                'JPEG',
                0,
                position,
                this.Analysisw,
                this.Analysish,
              );
              curStep++;
            } else if (index === 6) {
              if (htmlHeight + Careersimulationh < 1500) {
                // 内容
                this.pdf.addImage(
                  pageData,
                  'JPEG',
                  0,
                  position,
                  imgWidth,
                  imgHeight,
                );
                // 生涯仿真
                this.pdf.addImage(
                  Careersimulationimg,
                  'JPEG',
                  0,
                  position + imgHeight,
                  Careersimulationw,
                  Careersimulationh,
                );
              } else {
                // 内容
                this.pdf.addImage(
                  pageData,
                  'JPEG',
                  0,
                  position,
                  imgWidth,
                  imgHeight,
                );
                this.pdf.addPage();
                // 生涯仿真
                this.pdf.addImage(
                  Careersimulationimg,
                  'JPEG',
                  0,
                  position,
                  Careersimulationw,
                  Careersimulationh,
                );
                judge = false;
                curStep++;
              }
            } else {
              // 内容
              this.pdf.addImage(
                pageData,
                'JPEG',
                0,
                position,
                imgWidth,
                imgHeight,
              );
            }
            // 页眉
            this.pdf.addImage(headerimg, 'JPEG', 0, 0, headerw, headerh);
            // 银行logo
            this.pdf.addImage(logoimg, 'JPEG', 30, 10, 59, 20);
            // 页脚
            this.pdf.addImage(
              footerimg,
              'JPEG',
              0,
              a4height - footerh,
              footerw,
              footerh,
            );
            // 页码
            this.pdf.setFontSize(10);
            this.pdf.setTextColor(150);
            this.pdf.text(297.64, 831.89, `-${curStep}-`);
            if (index !== 12) {
              if (index === 6) {
                if (htmlHeight + Careersimulationh < 1500) {
                  this.pdf.addPage();
                  curStep++;
                }
              } else {
                this.pdf.addPage();
                curStep++;
              }
            }
          } else {
            while (htmlHeight > 0) {
              if (judge) {
                // 内容
                this.pdf.addImage(
                  pageData,
                  'JPEG',
                  0,
                  position,
                  imgWidth,
                  imgHeight,
                );
              } else {
                // 内容
                this.pdf.addImage(
                  pageData,
                  'JPEG',
                  0,
                  position + Careersimulationh,
                  imgWidth,
                  imgHeight,
                );
                htmlHeight += Careersimulationh + footerh;
              }

              // 页眉
              this.pdf.addImage(headerimg, 'JPEG', 0, 0, headerw, headerh);
              // 银行logo
              this.pdf.addImage(logoimg, 'JPEG', 30, 10, 59, 20);
              // 页脚
              this.pdf.addImage(
                footerimg,
                'JPEG',
                0,
                a4height - footerh,
                footerw,
                footerh,
              );
              // 留白
              this.pdf.addImage(
                intervalimg,
                'JPEG',
                0,
                headerh,
                intervalw,
                intervalh,
              );
              this.pdf.addImage(
                intervalimg,
                'JPEG',
                0,
                a4height - footerh - intervalh,
                intervalw,
                intervalh,
              );
              // 页码
              this.pdf.setFontSize(10);
              this.pdf.setTextColor(150);
              this.pdf.text(297.64, 831.89, `-${curStep}-`);
              htmlHeight -= pageHeight;
              if (htmlHeight < 0) {
                judge = true;
              }
              position -= 841.89 - footerh - headerh - intervalh - intervalh;
              // 避免添加空白页
              if (htmlHeight > 0) {
                this.pdf.addPage();
                curStep++;
              } else if (index !== 12) {
                position = 40;
                this.pdf.addPage();
                curStep++;
              }
            }
          }
          this.curStep = index;
          if (this.curStep === 12) {
            this.pdfBase64 = this.pdf.output('datauristring');
            this.$emit('assemblyTwo', loading);
          }
        });
      });
    },
    // 将图片转码
    getImageBase64 (img, ext) {
      let canvas = document.createElement('canvas'); // 创建canvas DOM元素，并设置其宽高和图片一样
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, img.width, img.height); // 使用画布画图
      const dataURL = canvas.toDataURL(`image/${ext}`); // 返回的是一串Base64编码的URL并指定格式
      canvas = null; // 释放
      return dataURL;
    },
    // 计算总和
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        // eslint-disable-next-line no-restricted-globals
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            // eslint-disable-next-line no-restricted-globals
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0);
          sums[index] = this.fmtCustFinanceInfo(sums[index]);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    // 合并单元格
    // eslint-disable-next-line consistent-return
    arraySpanMethod ({
      // eslint-disable-next-line no-unused-vars
      row, column, rowIndex, columnIndex,
    }) {
      if (row.name === '合计') {
        if (columnIndex === 1) {
          return [2, 2];
        }
        if (columnIndex === 3) {
          return [2, 2];
        }
        if (columnIndex === 2) {
          return [0, 0];
        }
        if (columnIndex === 4) {
          return [0, 0];
        }
      }
    },
  },
};
</script>
<style lang="scss">
#root {
  position: absolute;
  top: 100%;
  .el-table tr {
    background: rgba($color: #c7010e, $alpha: 0.1);
  }
  .el-table__header-wrapper {
    color: black;
    font-size: 25px;
    font-family: SimHei;
    border-top: 1px #4a4a4a solid;
    border-bottom: 1px #4a4a4a solid;
  }
  .el-table__footer-wrapper {
    .is-leaf {
      color: #c7010e;
    }
  }

  > div {
    margin: 0 auto;
    background: #ffffff;
  }
  font-size: 20px;
  color: black;
  font-weight: bold;
  font-family: STSongti-SC-Regular, STSongti-SC;
}
#logo {
  position: relative;
  left: 330px;
  top: 50px;
}
.pageOne {
  > div {
    &:nth-child(1) {
      width: 520px;
      margin: 0 auto;
    }
    &:nth-child(2) {
      text-align: right;
    }
  }
  width: 1000px;
  padding: 20px 50px;
}
.title1 {
  font-size: 40px;
  font-weight: bold;
  padding: 20px 0;
}
.Division {
  height: 4px;
  background: linear-gradient(
    90deg,
    rgba(199, 1, 14, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}
.title3 {
  padding: 20px 0;
  font-size: 25px;
  color: rgba(199, 1, 14, 1);
}
.title4 {
  font-size: 20px;
  padding: 5px 0;
}
#header {
  width: 1000px;
  font-size: 20px;
  display: flex;
  justify-content: space-around;
  padding: 20px 0px;
  border-bottom: 2px solid #9b9b9b;
}
#footer {
  width: 1000px;
  color: #303133;
  padding: 20px 50px;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #9b9b9b;
}
#interval {
  width: 1100px;
  height: 50px;
  background: #fff;
}
#coverText {
  p {
    font-size: 30px;
    color: rgba(0, 0, 0, 1);
  }
  span {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.52);
  }
}
.step1 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
  }
  .indent {
    text-indent: 2em;
  }
  .right {
    text-align: right;
  }
}
.step2 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  .el-table tr {
    background: rgba($color: #c7010e, $alpha: 0.1);
  }
  .contentOne {
    .relationship {
      display: flex;
      justify-content: space-between;
    }
    p {
      margin: 20px 0px;
      text-indent: 2em;
    }
  }
  .contentTwo {
    p {
      margin: 20px 0px;
      text-indent: 2em;
      span {
        color: #c7010e;
      }
    }
    div {
      display: flex;
      flex-direction: row;
      > span {
        display: inline-block;
        width: 20%;
        height: 20px;
        padding: 5px 0px;
        .ArrowShow {
          text-align: center;
          position: relative;
          top: -23px;
          display: flex;
          flex-direction: column;
        }
        .Arrow {
          position: relative;
          top: -3px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &:nth-child(1) {
          background: rgba(199, 1, 14, 0.1);
        }
        &:nth-child(2) {
          background: rgba(199, 1, 14, 0.3);
        }
        &:nth-child(3) {
          background: rgba(199, 1, 14, 0.5);
        }
        &:nth-child(4) {
          background: rgba(199, 1, 14, 0.7);
        }
        &:nth-child(5) {
          background: rgba(199, 1, 14, 0.9);
        }
      }
    }
  }
}
.step3 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
}
.step4 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
  .chart {
    color: rgba(134, 131, 131, 0.616);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
    div {
      text-align: center;
      span {
        color: rgba(0, 0, 0, 1);
      }
    }
  }
  .assets {
    display: flex;
    flex-direction: row;
  }
}
.step5 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  border-bottom: 1px solid p {
    margin: 20px 0px;
  }
  table {
    width: 100%;
    .Header {
      border-top: 1px solid #4a4a4a;
      border-bottom: 1px solid #4a4a4a;
    }
    th {
      &:nth-child(1) {
        width: 20%;
      }
      &:nth-child(2) {
        width: 20%;
      }
      &:nth-child(3) {
        width: 15%;
      }
      &:nth-child(4) {
        width: 45%;
      }
      padding: 10px 0px;
      .dialogBottom-left {
        width: 100%;
        background: #f5f7fa;
        margin-right: 42px;
        div {
          width: 291px;
          height: 84px;
          text-align: center;
          line-height: 84px;
          img {
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 13px;
          }
          span {
            font-size: 14px;
            color: #c0c4cc;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      .dialogBottom-right {
        width: 50%;
        p {
          font-size: 20px;
          color: #606266;
          line-height: 20px;
        }
      }
      .dialogTop-left {
        // margin-right: 42px;
        // width: calc(50% - 42px);
        > div {
          width: 281px;
          height: 10px;
          border: 1px solid #606266;
          border-top: 0;
          position: relative;
          // left: 50px;
          > p {
            position: absolute;
            width: 35px;
            left: 0;
            top: -40px;
            bottom: 30px;
            font-size: 14px;
            color: #303133;
            letter-spacing: 0.67px;
          }
          img {
            position: absolute;
            left: 0;
            bottom: 5px;
          }
          > div {
            background: rgba(2, 187, 111, 0.2);
            border: 1px dashed #02bb6f;
            border-bottom: 0;
            width: 193px;
            height: 18px;
            position: absolute;
            left: 0;
            bottom: 0;
          }
          > ul {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: nowrap;
            position: relative;
            li {
              &:nth-child(1) {
                position: absolute;
                left: -5px;
                top: 20px;
              }
              &:nth-child(2) {
                position: absolute;
                left: 66%;
                top: 20px;
              }
              &:nth-child(3) {
                position: absolute;
                right: -10px;
                top: 20px;
              }
            }
          }
        }
        .assets-one {
          width: 33.33%;
          left: 33.33%;
        }
        .assets-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 33%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              left: 30%;
              top: 20px;
            }
            &:nth-child(4) {
              position: absolute;
              right: -5px;
              top: 20px;
            }
          }
        }
        .savings-one {
          width: 20%;
          left: 40%;
        }
        .savings-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 38%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              left: 20%;
              top: 20px;
            }
            &:nth-child(4) {
              position: absolute;
              right: -10px;
              top: 20px;
            }
          }
        }
        .finance-one-1 {
          width: 10%;
          left: 5%;
        }
        .finance-one-2 {
          width: 15%;
          left: 15%;
        }
        .finance-one-3 {
          width: 20%;
          left: 30%;
        }
        .finance-one-4 {
          width: 50%;
          left: 50%;
        }
        .finance-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 3%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              left: -73%;
              top: 20px;
            }
            &:nth-child(4) {
              position: absolute;
              left: 28%;
              top: 20px;
            }
            &:nth-child(5) {
              position: absolute;
              left: 48%;
              top: 20px;
            }
            &:nth-child(6) {
              position: absolute;
              right: -10px;
              top: 20px;
            }
          }
        }
        .labilities-one {
          width: 50%;
          position: absolute;
          left: -1px;
        }
        .labilities-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 47%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              right: -10px;
              top: 20px;
            }
          }
        }
      }
      .dialogTop-right {
        width: 80%;
        p {
          text-align: left;
          font-size: 20px;
          color: #606266;
          line-height: 20px;
          span {
            font-size: 20px;
            letter-spacing: -0.1px;
            line-height: 20px;
          }
        }
      }
    }
  }
}
.step6 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
  .bottomPart {
    padding: 20px 0px;
    display: flex;
    flex-wrap: wrap;
    .children {
      margin: 10px;
      background: rgba(199, 1, 14, 0.1);
      display: inline-block;
      width: 44%;
      padding: 9px 17px;
    }
  }
  .content {
    p {
      margin: 0px;
      text-indent: 0em;
    }
    .red {
      color: #c7010e;
    }
  }
}
.Careersimulation {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
}
.step7 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
    span {
      color: red;
    }
  }
  .chart {
    display: flex;
    flex-direction: row;
  }
}
.step8 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
  .content {
    p {
      margin: 0px;
      text-indent: 0em;
    }
    .red {
      color: #c7010e;
    }
  }
}
.step9 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
    span {
      color: red;
    }
  }
  .chart {
    display: flex;
    flex-direction: row;
  }
}
.step10 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
}
.step11 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
}
.step12 {
  width: 1000px;
  padding: 20px 50px;
  font-size: 20px;
  p {
    margin: 20px 0px;
    text-indent: 2em;
  }
}
.preview {
  padding: 20px 0px;
  width: 100%;
  height: 100%;
  background: #525659;
  > div {
    width: 793px;
    height: 1080px;
    background: #fff;
    &:nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
